// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import {
  authV3GetAuthCode,
  authV3JoinOrgByDomain,
  authV3Login,
  authV3LogOut,
  authV3Register,
  authV3SamlConsume,
  authValidateToken,
  availableLayersList,
  civilsearchAddAgencyLink,
  civilsearchAddAgencyLogo,
  civilsearchAddCivilSearchMessage,
  civilsearchAddCivilSearchMessageFile,
  civilsearchAddDataRequestFile,
  civilsearchAddDataRequestNote,
  civilsearchAddDataRequestUpdate,
  civilsearchAddDigitizationAccess,
  civilsearchAddNewInvoice,
  civilsearchAddSupportingFile,
  civilsearchArchiveAgencySubGeometry,
  civilsearchBulkCreateDataRequestNotes,
  civilsearchBulkUpdateDataRequests,
  civilsearchCreateAgencySubGeometry,
  civilsearchCreateMissiveEmailDraft,
  civilsearchCreateUtilityChecks,
  civilsearchDeleteAgencyLink,
  civilsearchDeleteDataRequestFile,
  civilsearchDeleteDataRequestNote,
  civilsearchDeleteDataRequestUpdate,
  civilsearchDeleteSupportingFile,
  civilsearchEditAgencyLink,
  civilsearchGetAgencies,
  civilsearchGetAgency,
  civilsearchGetAgencyGeometries,
  civilsearchGetAgencySubGeometries,
  civilsearchGetAiProjectDescription,
  civilsearchGetCivilSearchers,
  civilsearchGetCivilSearchFileDownloadUrl,
  civilsearchGetCivilSearchMessages,
  civilsearchGetDataRequest,
  civilsearchGetDataRequests,
  civilsearchGetMergeHistory,
  civilsearchGetProject,
  civilsearchGetProjectUtilityChecks,
  civilsearchGetRecordRequestData,
  civilsearchGetSupportingFiles,
  civilsearchGetUtilityChecksByProject,
  civilsearchListFilteredAgencies,
  civilsearchListFilteredDataRequests,
  civilsearchListFilteredProjects,
  civilsearchMergeAgencies,
  civilsearchMergeAgenciesPreview,
  civilsearchNewAgencyContact,
  civilsearchRemoveDigitizationAccess,
  civilsearchSearchOrganizations,
  civilsearchSearchProjects,
  civilsearchUpdateAgency,
  civilsearchUpdateAgencyContact,
  civilsearchUpdateAgencySubGeometry,
  civilsearchUpdateAgencySubGeometryNote,
  civilsearchUpdateCivilSearchers,
  civilsearchUpdateDataRequest,
  civilsearchUpdateDataRequestNote,
  civilsearchUpdateInvoice,
  civilsearchUpdateRequestAssignmentsByProjectId,
  civilsearchUpdateRequestFileReferences,
  commentThreadsV3CreateComment,
  commentThreadsV3CreateCommentThread,
  commentThreadsV3DeleteComment,
  commentThreadsV3DeleteCommentThread,
  commentThreadsV3GetCommentThread,
  commentThreadsV3ListCommentThreads,
  commentThreadsV3ListTaggableUsers,
  commentThreadsV3ReopenCommentThread,
  commentThreadsV3ResolveCommentThread,
  commentThreadsV3RestoreCommentThread,
  commentThreadsV3UpdateComment,
  dataRefreshStatusList,
  dataStoreMessageHandler,
  drawingsV3ApplyChanges,
  drawingsV3ArchiveDrawing,
  drawingsV3CreateDrawing,
  drawingsV3DuplicateDrawing,
  drawingsV3GetDrawing,
  drawingsV3GetHistory,
  drawingsV3ListChanges,
  drawingsV3ListDrawings,
  drawingsV3RestoreDrawing,
  drawingsV3UpdateDrawing,
  drfCreatePaymentIntent,
  drfExportDrfTableToExcel,
  drfGetDrfRequestActivities,
  drfListDrfRequests,
  drfRegenerateApprovalPacket,
  drfSubmitRequest,
  drfUpdateDrfRequest,
  drfUploadCeiiFile,
  drfValidateGoogleRecaptcha,
  extractGetDefaultExtractProjection,
  extractGetExtractProjections,
  extractGetExtractResources,
  extractGetFiberLitBuildings,
  extractGetFiberRoutes,
  extractGetOrganizationExtractTemplates,
  extractNotifyExtractResult,
  extractProjectExtract,
  filesAddSingleFile,
  filesDeleteSingleFile,
  healthTick,
  internalActivateExtractAutomation,
  internalAddTransaction,
  internalArchiveExportEscalation,
  internalAssignExtractTemplate,
  internalClearEsriCache,
  internalComputeIntelligence,
  internalCreateExtractAutomation,
  internalCreateExtractTemplate,
  internalCreateOrganization,
  internalCreateSandboxOrg,
  internalDeleteExtractAutomation,
  internalGetAdminTileLayers,
  internalGetAllOrganizations,
  internalGetAllUsers,
  internalGetDemoOrgs,
  internalGetExportEscalation,
  internalGetExtractAdminState,
  internalGetInternalAdminUsers,
  internalGetOrganization,
  internalGetOrganizationSubscriptions,
  internalGetPgeCloudSyncFolders,
  internalGetSpecialDatasetSlugs,
  internalGetSubscriptionsStatus,
  internalJoinOrgAsAdmin,
  internalListExportEscalations,
  internalListOrgProjectsAsAdm,
  internalLoadStagingLayerCatalog,
  internalPrintOrgInvoice,
  internalPromoteGisConfig,
  internalRefreshTileConfig,
  internalRefreshTiles,
  internalResetDemoOrg,
  internalRestoreGeoItemRevision,
  internalRunAgencyLoader,
  internalRunExportEscalation,
  internalSetUserToApproved,
  internalSetUserToOnboarded,
  internalSyncExtractProjections,
  internalSyncIntelligence,
  internalToggleIsBillable,
  internalTriggerDigestForProject,
  internalTriggerPgeCloudSyncWorkflow,
  internalUpdateDisabledTileLayers,
  internalUpdateExportEscalationNotes,
  internalUpdateLinkedOrganizations,
  internalUpdateOrganizationAccountType,
  internalUpdateOrganizationSubscription,
  internalUpdateOrgConnectbaseLookup,
  internalUpdateOrgPlan,
  internalUpdateOrgSpecialDatasets,
  internalUpdateSubscriptionContractEndsOn,
  internalUpdateTelcoAccess,
  miscCalculateWatershedRisk,
  miscGet811Data,
  miscLogEvent,
  miscV2GetAgenciesSummary,
  miscV2GetParcelSuggestions,
  miscV2GetProjectionList,
  miscV2GetZoningDetailsAtPoint,
  miscV2IsUrbanArea,
  miscV2PrintMap,
  miscV2TranscodeImage,
  miscV2ValidateGeometry,
  mobileVersionGet,
  mobileVersionUpdate,
  type Options,
  organizationsAddFile,
  organizationsAddMembers,
  organizationsEdit,
  organizationsEditMember,
  organizationsEditRole,
  organizationsGet,
  organizationsGetBillingSummary,
  organizationsGetMembers,
  organizationsGetMyOrganizations,
  organizationsGetOrgSummary,
  organizationsPrintBillingSummary,
  organizationsResendInvite,
  organizationsSetTestEnvOverride,
  orgLayerConfigGet,
  orgLayerConfigUpdate,
  preferencesUpdateProjectMemberNotifications,
  projectsAddFile,
  projectsAddParcelDetails,
  projectsCheckForSoilsRequest,
  projectsCreateGeoItem,
  projectsDeleteFile,
  projectsDeleteGeoItem,
  projectsEditGeoItem,
  projectsFetchGeotech,
  projectsGetProjectFeatures,
  projectsGetStatePlaneZone,
  projectsGetZoningData,
  projectsListGeoItems,
  projectsParcelPointQuery,
  projectsPrintGeoItem,
  projectsPrintProjectPdf,
  projectsRequestData,
  projectsSoilsRequest,
  projectsUpdateFile,
  projectsV2AddComment,
  projectsV2AddIntelligenceComment,
  projectsV2AddMap,
  projectsV2AddMembers,
  projectsV2AddObject,
  projectsV2AddObjectFile,
  projectsV2AddObjects,
  projectsV2AddProject,
  projectsV2ArchiveComment,
  projectsV2ArchiveProject,
  projectsV2DeleteIntelligenceComment,
  projectsV2DeleteMap,
  projectsV2DeleteObject,
  projectsV2DeleteObjectFiles,
  projectsV2DeletePermit,
  projectsV2DownloadCsAttachments,
  projectsV2DuplicateMap,
  projectsV2EditProject,
  projectsV2EditProjectGeometry,
  projectsV2ExportIntelligenceSummariesToExcel,
  projectsV2GenerateEvidenceEmailChain,
  projectsV2GenerateFloodReport,
  projectsV2GenerateProposalPacket,
  projectsV2GenerateRecordsResearchReport,
  projectsV2GetAntennaData,
  projectsV2GetCgsRegulatoryQuadrangleList,
  projectsV2GetCivilSearchActivities,
  projectsV2GetCivilSearchMessages,
  projectsV2GetDataRequestsV2,
  projectsV2GetDigitizationAccess,
  projectsV2GetDownloadRestrictions,
  projectsV2GetDownloadSignedUrl,
  projectsV2GetEnvironmentalStudyData,
  projectsV2GetEnvironmentalStudyPdf,
  projectsV2GetEnvironmentalSummary,
  projectsV2GetGeotechnicalSummary,
  projectsV2GetHistoricalUsgsMaps,
  projectsV2GetIntelligenceFeatures,
  projectsV2GetLandRightsSummary,
  projectsV2GetLatestCivilSearchActivity,
  projectsV2GetLayers,
  projectsV2GetMap,
  projectsV2GetParcelData,
  projectsV2GetPermit,
  projectsV2GetProject,
  projectsV2GetProjectAgencies,
  projectsV2GetProjectDownloads,
  projectsV2GetProjectLayerAssetPresence,
  projectsV2GetStoredFileDownloadUrl,
  projectsV2GetUtilitiesFileSignedUrl,
  projectsV2GetUtilitiesSummary,
  projectsV2GetUtilityAgencies,
  projectsV2JoinProject,
  projectsV2LeaveProject,
  projectsV2ListIntelligenceSummaries,
  projectsV2ListMaps,
  projectsV2ListProjectsV2,
  projectsV2ListTransactions,
  projectsV2NewCivilSearchMessage,
  projectsV2PopulateProjectAgenciesData,
  projectsV2PrintQuote,
  projectsV2PrintReceipt,
  projectsV2RemoveMember,
  projectsV2RequestErisData,
  projectsV2SubmitDataRequestsV2,
  projectsV2SubmitDownloadRequest,
  projectsV2UndoDeleteObject,
  projectsV2UpdateBillingTier,
  projectsV2UpdateComment,
  projectsV2UpdateIntelligenceStatus,
  projectsV2UpdateIntelligenceSummary,
  projectsV2UpdateMap,
  projectsV2UpdateObject,
  projectsV2UpdateUtilityNote,
  projectsV2UpsertPermit,
  projectsV3AddShapefileCustomData,
  projectsV3AddWmtsCustomData,
  projectsV3BulkAddProjectBookmarks,
  projectsV3BulkInviteMembers,
  projectsV3BulkUpdateConstructionDates,
  projectsV3BulkUpdatePlanStatus,
  projectsV3BulkUpdateProjects,
  projectsV3DeleteCustomData,
  projectsV3DownloadCustomDataSource,
  projectsV3ExportIntelligenceSummariesToExcel,
  projectsV3ExportProjectsToExcel,
  projectsV3GetIntelligenceSummaryMeta,
  projectsV3GetProjectIntelligence,
  projectsV3GetSandboxProject,
  projectsV3InspectWmtsCustomData,
  projectsV3InviteMembers,
  projectsV3ListAllProjects,
  projectsV3ListCustomData,
  projectsV3ListGeoRefMapsForProject,
  projectsV3ListIntelligenceSummaries,
  projectsV3ListProjectAgencyHistory,
  projectsV3ListProjectConnectbaseTasks,
  projectsV3ListProjects,
  projectsV3SetCustomDataCategories,
  projectsV3SetCustomDataLabel,
  projectsV3SetCustomDataVisibility,
  projectsV3ToggleProjectBookmark,
  reportProblemCreate,
  tileLayersList,
  titleGetDocumentById,
  titleGetDocumentByIdDownload,
  titleGetDocumentsByIds,
  titleGetDocumentsByIdsDownload,
  titleGetParcelDetails,
  titleGetReportDocs,
  titleGetReportDocsDownload,
  titleGetTitleReport,
  titleOrderPrelimTitleReport,
  uploadsV3GetUpload,
  uploadsV3PresignUpload,
  uploadsV3RegisterUpload,
  userLayerConfigGet,
  userLayerConfigSeed,
  userLayerConfigUpdate,
  usersCheckIfDomainAllowed,
  usersCreateOrganization,
  usersFailedVerification,
  usersGetMe,
  usersSkipVerification,
  usersUpdateProfile,
  usersUpdateProjectBookmarks,
  usersUserCompletedVerification,
  verificationHandleWebhook,
} from '../sdk.gen';
import type {
  AuthV3GetAuthCodeData,
  AuthV3GetAuthCodeResponse,
  AuthV3JoinOrgByDomainData,
  AuthV3JoinOrgByDomainResponse,
  AuthV3LoginData,
  AuthV3LoginResponse,
  AuthV3LogOutData,
  AuthV3LogOutResponse,
  AuthV3RegisterData,
  AuthV3RegisterResponse,
  AuthV3SamlConsumeData,
  AuthV3SamlConsumeResponse,
  AuthValidateTokenData,
  AuthValidateTokenResponse,
  AvailableLayersListData,
  AvailableLayersListResponse,
  CivilsearchAddAgencyLinkData,
  CivilsearchAddAgencyLinkResponse,
  CivilsearchAddAgencyLogoData,
  CivilsearchAddAgencyLogoResponse,
  CivilsearchAddCivilSearchMessageData,
  CivilsearchAddCivilSearchMessageFileData,
  CivilsearchAddCivilSearchMessageFileResponse,
  CivilsearchAddCivilSearchMessageResponse,
  CivilsearchAddDataRequestFileData,
  CivilsearchAddDataRequestFileResponse,
  CivilsearchAddDataRequestNoteData,
  CivilsearchAddDataRequestNoteResponse,
  CivilsearchAddDataRequestUpdateData,
  CivilsearchAddDataRequestUpdateResponse,
  CivilsearchAddDigitizationAccessData,
  CivilsearchAddDigitizationAccessResponse,
  CivilsearchAddNewInvoiceData,
  CivilsearchAddNewInvoiceResponse,
  CivilsearchAddSupportingFileData,
  CivilsearchAddSupportingFileResponse,
  CivilsearchArchiveAgencySubGeometryData,
  CivilsearchArchiveAgencySubGeometryResponse,
  CivilsearchBulkCreateDataRequestNotesData,
  CivilsearchBulkCreateDataRequestNotesResponse,
  CivilsearchBulkUpdateDataRequestsData,
  CivilsearchBulkUpdateDataRequestsResponse,
  CivilsearchCreateAgencySubGeometryData,
  CivilsearchCreateAgencySubGeometryResponse,
  CivilsearchCreateMissiveEmailDraftData,
  CivilsearchCreateMissiveEmailDraftResponse,
  CivilsearchCreateUtilityChecksData,
  CivilsearchCreateUtilityChecksResponse,
  CivilsearchDeleteAgencyLinkData,
  CivilsearchDeleteAgencyLinkResponse,
  CivilsearchDeleteDataRequestFileData,
  CivilsearchDeleteDataRequestFileResponse,
  CivilsearchDeleteDataRequestNoteData,
  CivilsearchDeleteDataRequestNoteResponse,
  CivilsearchDeleteDataRequestUpdateData,
  CivilsearchDeleteDataRequestUpdateResponse,
  CivilsearchDeleteSupportingFileData,
  CivilsearchDeleteSupportingFileResponse,
  CivilsearchEditAgencyLinkData,
  CivilsearchEditAgencyLinkResponse,
  CivilsearchGetAgenciesData,
  CivilsearchGetAgenciesResponse,
  CivilsearchGetAgencyData,
  CivilsearchGetAgencyGeometriesData,
  CivilsearchGetAgencyGeometriesResponse,
  CivilsearchGetAgencyResponse,
  CivilsearchGetAgencySubGeometriesData,
  CivilsearchGetAgencySubGeometriesResponse,
  CivilsearchGetAiProjectDescriptionData,
  CivilsearchGetAiProjectDescriptionResponse,
  CivilsearchGetCivilSearchersData,
  CivilsearchGetCivilSearchersResponse,
  CivilsearchGetCivilSearchFileDownloadUrlData,
  CivilsearchGetCivilSearchFileDownloadUrlResponse,
  CivilsearchGetCivilSearchMessagesData,
  CivilsearchGetCivilSearchMessagesResponse,
  CivilsearchGetDataRequestData,
  CivilsearchGetDataRequestResponse,
  CivilsearchGetDataRequestsData,
  CivilsearchGetDataRequestsResponse,
  CivilsearchGetMergeHistoryData,
  CivilsearchGetMergeHistoryResponse,
  CivilsearchGetProjectData,
  CivilsearchGetProjectResponse,
  CivilsearchGetProjectUtilityChecksData,
  CivilsearchGetProjectUtilityChecksResponse,
  CivilsearchGetRecordRequestDataData,
  CivilsearchGetRecordRequestDataResponse,
  CivilsearchGetSupportingFilesData,
  CivilsearchGetSupportingFilesResponse,
  CivilsearchGetUtilityChecksByProjectData,
  CivilsearchGetUtilityChecksByProjectResponse,
  CivilsearchListFilteredAgenciesData,
  CivilsearchListFilteredAgenciesResponse,
  CivilsearchListFilteredDataRequestsData,
  CivilsearchListFilteredDataRequestsResponse,
  CivilsearchListFilteredProjectsData,
  CivilsearchListFilteredProjectsResponse,
  CivilsearchMergeAgenciesData,
  CivilsearchMergeAgenciesPreviewData,
  CivilsearchMergeAgenciesPreviewResponse,
  CivilsearchMergeAgenciesResponse,
  CivilsearchNewAgencyContactData,
  CivilsearchNewAgencyContactResponse,
  CivilsearchRemoveDigitizationAccessData,
  CivilsearchRemoveDigitizationAccessResponse,
  CivilsearchSearchOrganizationsData,
  CivilsearchSearchOrganizationsResponse,
  CivilsearchSearchProjectsData,
  CivilsearchSearchProjectsResponse,
  CivilsearchUpdateAgencyContactData,
  CivilsearchUpdateAgencyContactResponse,
  CivilsearchUpdateAgencyData,
  CivilsearchUpdateAgencyResponse,
  CivilsearchUpdateAgencySubGeometryData,
  CivilsearchUpdateAgencySubGeometryNoteData,
  CivilsearchUpdateAgencySubGeometryNoteResponse,
  CivilsearchUpdateAgencySubGeometryResponse,
  CivilsearchUpdateCivilSearchersData,
  CivilsearchUpdateCivilSearchersResponse,
  CivilsearchUpdateDataRequestData,
  CivilsearchUpdateDataRequestNoteData,
  CivilsearchUpdateDataRequestNoteResponse,
  CivilsearchUpdateDataRequestResponse,
  CivilsearchUpdateInvoiceData,
  CivilsearchUpdateInvoiceResponse,
  CivilsearchUpdateRequestAssignmentsByProjectIdData,
  CivilsearchUpdateRequestAssignmentsByProjectIdResponse,
  CivilsearchUpdateRequestFileReferencesData,
  CivilsearchUpdateRequestFileReferencesResponse,
  CommentThreadsV3CreateCommentData,
  CommentThreadsV3CreateCommentResponse,
  CommentThreadsV3CreateCommentThreadData,
  CommentThreadsV3CreateCommentThreadResponse,
  CommentThreadsV3DeleteCommentData,
  CommentThreadsV3DeleteCommentResponse,
  CommentThreadsV3DeleteCommentThreadData,
  CommentThreadsV3DeleteCommentThreadResponse,
  CommentThreadsV3GetCommentThreadData,
  CommentThreadsV3GetCommentThreadResponse,
  CommentThreadsV3ListCommentThreadsData,
  CommentThreadsV3ListCommentThreadsResponse,
  CommentThreadsV3ListTaggableUsersData,
  CommentThreadsV3ListTaggableUsersResponse,
  CommentThreadsV3ReopenCommentThreadData,
  CommentThreadsV3ReopenCommentThreadResponse,
  CommentThreadsV3ResolveCommentThreadData,
  CommentThreadsV3ResolveCommentThreadResponse,
  CommentThreadsV3RestoreCommentThreadData,
  CommentThreadsV3RestoreCommentThreadResponse,
  CommentThreadsV3UpdateCommentData,
  CommentThreadsV3UpdateCommentResponse,
  DataRefreshStatusListData,
  DataRefreshStatusListResponse,
  DataStoreMessageHandlerData,
  DataStoreMessageHandlerResponse,
  DrawingsV3ApplyChangesData,
  DrawingsV3ApplyChangesResponse,
  DrawingsV3ArchiveDrawingData,
  DrawingsV3ArchiveDrawingResponse,
  DrawingsV3CreateDrawingData,
  DrawingsV3CreateDrawingResponse,
  DrawingsV3DuplicateDrawingData,
  DrawingsV3DuplicateDrawingResponse,
  DrawingsV3GetDrawingData,
  DrawingsV3GetDrawingResponse,
  DrawingsV3GetHistoryData,
  DrawingsV3GetHistoryResponse,
  DrawingsV3ListChangesData,
  DrawingsV3ListChangesResponse,
  DrawingsV3ListDrawingsData,
  DrawingsV3ListDrawingsResponse,
  DrawingsV3RestoreDrawingData,
  DrawingsV3RestoreDrawingResponse,
  DrawingsV3UpdateDrawingData,
  DrawingsV3UpdateDrawingResponse,
  DrfCreatePaymentIntentData,
  DrfCreatePaymentIntentResponse,
  DrfExportDrfTableToExcelData,
  DrfExportDrfTableToExcelResponse,
  DrfGetDrfRequestActivitiesData,
  DrfGetDrfRequestActivitiesResponse,
  DrfListDrfRequestsData,
  DrfListDrfRequestsResponse,
  DrfRegenerateApprovalPacketData,
  DrfRegenerateApprovalPacketResponse,
  DrfSubmitRequestData,
  DrfSubmitRequestResponse,
  DrfUpdateDrfRequestData,
  DrfUpdateDrfRequestResponse,
  DrfUploadCeiiFileData,
  DrfUploadCeiiFileResponse,
  DrfValidateGoogleRecaptchaData,
  DrfValidateGoogleRecaptchaResponse,
  ExtractGetDefaultExtractProjectionData,
  ExtractGetDefaultExtractProjectionResponse,
  ExtractGetExtractProjectionsData,
  ExtractGetExtractProjectionsResponse,
  ExtractGetExtractResourcesData,
  ExtractGetExtractResourcesResponse,
  ExtractGetFiberLitBuildingsData,
  ExtractGetFiberLitBuildingsResponse,
  ExtractGetFiberRoutesData,
  ExtractGetFiberRoutesResponse,
  ExtractGetOrganizationExtractTemplatesData,
  ExtractGetOrganizationExtractTemplatesResponse,
  ExtractNotifyExtractResultData,
  ExtractNotifyExtractResultResponse,
  ExtractProjectExtractData,
  ExtractProjectExtractResponse,
  FilesAddSingleFileData,
  FilesAddSingleFileResponse,
  FilesDeleteSingleFileData,
  FilesDeleteSingleFileResponse,
  HealthTickData,
  HealthTickResponse,
  InternalActivateExtractAutomationData,
  InternalActivateExtractAutomationResponse,
  InternalAddTransactionData,
  InternalAddTransactionResponse,
  InternalArchiveExportEscalationData,
  InternalArchiveExportEscalationResponse,
  InternalAssignExtractTemplateData,
  InternalAssignExtractTemplateResponse,
  InternalClearEsriCacheData,
  InternalClearEsriCacheResponse,
  InternalComputeIntelligenceData,
  InternalComputeIntelligenceResponse,
  InternalCreateExtractAutomationData,
  InternalCreateExtractAutomationResponse,
  InternalCreateExtractTemplateData,
  InternalCreateExtractTemplateResponse,
  InternalCreateOrganizationData,
  InternalCreateOrganizationResponse,
  InternalCreateSandboxOrgData,
  InternalCreateSandboxOrgResponse,
  InternalDeleteExtractAutomationData,
  InternalDeleteExtractAutomationResponse,
  InternalGetAdminTileLayersData,
  InternalGetAdminTileLayersResponse,
  InternalGetAllOrganizationsData,
  InternalGetAllOrganizationsResponse,
  InternalGetAllUsersData,
  InternalGetAllUsersResponse,
  InternalGetDemoOrgsData,
  InternalGetDemoOrgsResponse,
  InternalGetExportEscalationData,
  InternalGetExportEscalationResponse,
  InternalGetExtractAdminStateData,
  InternalGetExtractAdminStateResponse,
  InternalGetInternalAdminUsersData,
  InternalGetInternalAdminUsersResponse,
  InternalGetOrganizationData,
  InternalGetOrganizationResponse,
  InternalGetOrganizationSubscriptionsData,
  InternalGetOrganizationSubscriptionsResponse,
  InternalGetPgeCloudSyncFoldersData,
  InternalGetPgeCloudSyncFoldersResponse,
  InternalGetSpecialDatasetSlugsData,
  InternalGetSpecialDatasetSlugsResponse,
  InternalGetSubscriptionsStatusData,
  InternalGetSubscriptionsStatusResponse,
  InternalJoinOrgAsAdminData,
  InternalJoinOrgAsAdminResponse,
  InternalListExportEscalationsData,
  InternalListExportEscalationsResponse,
  InternalListOrgProjectsAsAdmData,
  InternalListOrgProjectsAsAdmResponse,
  InternalLoadStagingLayerCatalogData,
  InternalLoadStagingLayerCatalogResponse,
  InternalPrintOrgInvoiceData,
  InternalPrintOrgInvoiceResponse,
  InternalPromoteGisConfigData,
  InternalPromoteGisConfigResponse,
  InternalRefreshTileConfigData,
  InternalRefreshTileConfigResponse,
  InternalRefreshTilesData,
  InternalRefreshTilesResponse,
  InternalResetDemoOrgData,
  InternalResetDemoOrgResponse,
  InternalRestoreGeoItemRevisionData,
  InternalRestoreGeoItemRevisionResponse,
  InternalRunAgencyLoaderData,
  InternalRunAgencyLoaderResponse,
  InternalRunExportEscalationData,
  InternalRunExportEscalationResponse,
  InternalSetUserToApprovedData,
  InternalSetUserToApprovedResponse,
  InternalSetUserToOnboardedData,
  InternalSetUserToOnboardedResponse,
  InternalSyncExtractProjectionsData,
  InternalSyncExtractProjectionsResponse,
  InternalSyncIntelligenceData,
  InternalSyncIntelligenceResponse,
  InternalToggleIsBillableData,
  InternalToggleIsBillableResponse,
  InternalTriggerDigestForProjectData,
  InternalTriggerDigestForProjectResponse,
  InternalTriggerPgeCloudSyncWorkflowData,
  InternalTriggerPgeCloudSyncWorkflowResponse,
  InternalUpdateDisabledTileLayersData,
  InternalUpdateDisabledTileLayersResponse,
  InternalUpdateExportEscalationNotesData,
  InternalUpdateExportEscalationNotesResponse,
  InternalUpdateLinkedOrganizationsData,
  InternalUpdateLinkedOrganizationsResponse,
  InternalUpdateOrganizationAccountTypeData,
  InternalUpdateOrganizationAccountTypeResponse,
  InternalUpdateOrganizationSubscriptionData,
  InternalUpdateOrganizationSubscriptionResponse,
  InternalUpdateOrgConnectbaseLookupData,
  InternalUpdateOrgConnectbaseLookupResponse,
  InternalUpdateOrgPlanData,
  InternalUpdateOrgPlanResponse,
  InternalUpdateOrgSpecialDatasetsData,
  InternalUpdateOrgSpecialDatasetsResponse,
  InternalUpdateSubscriptionContractEndsOnData,
  InternalUpdateSubscriptionContractEndsOnResponse,
  InternalUpdateTelcoAccessData,
  InternalUpdateTelcoAccessResponse,
  MiscCalculateWatershedRiskData,
  MiscCalculateWatershedRiskResponse,
  MiscGet811DataData,
  MiscGet811DataResponse,
  MiscLogEventData,
  MiscLogEventResponse,
  MiscV2GetAgenciesSummaryData,
  MiscV2GetAgenciesSummaryResponse,
  MiscV2GetParcelSuggestionsData,
  MiscV2GetParcelSuggestionsResponse,
  MiscV2GetProjectionListData,
  MiscV2GetProjectionListResponse,
  MiscV2GetZoningDetailsAtPointData,
  MiscV2GetZoningDetailsAtPointResponse,
  MiscV2IsUrbanAreaData,
  MiscV2IsUrbanAreaResponse,
  MiscV2PrintMapData,
  MiscV2PrintMapResponse,
  MiscV2TranscodeImageData,
  MiscV2TranscodeImageResponse,
  MiscV2ValidateGeometryData,
  MiscV2ValidateGeometryResponse,
  MobileVersionGetData,
  MobileVersionGetResponse,
  MobileVersionUpdateData,
  MobileVersionUpdateResponse,
  OrganizationsAddFileData,
  OrganizationsAddFileResponse,
  OrganizationsAddMembersData,
  OrganizationsAddMembersResponse,
  OrganizationsEditData,
  OrganizationsEditMemberData,
  OrganizationsEditMemberResponse,
  OrganizationsEditResponse,
  OrganizationsEditRoleData,
  OrganizationsEditRoleResponse,
  OrganizationsGetBillingSummaryData,
  OrganizationsGetBillingSummaryResponse,
  OrganizationsGetData,
  OrganizationsGetMembersData,
  OrganizationsGetMembersResponse,
  OrganizationsGetMyOrganizationsData,
  OrganizationsGetMyOrganizationsResponse,
  OrganizationsGetOrgSummaryData,
  OrganizationsGetOrgSummaryResponse,
  OrganizationsGetResponse,
  OrganizationsPrintBillingSummaryData,
  OrganizationsPrintBillingSummaryResponse,
  OrganizationsResendInviteData,
  OrganizationsResendInviteResponse,
  OrganizationsSetTestEnvOverrideData,
  OrganizationsSetTestEnvOverrideResponse,
  OrgLayerConfigGetData,
  OrgLayerConfigGetResponse,
  OrgLayerConfigUpdateData,
  OrgLayerConfigUpdateResponse,
  PreferencesUpdateProjectMemberNotificationsData,
  PreferencesUpdateProjectMemberNotificationsResponse,
  ProjectsAddFileData,
  ProjectsAddFileResponse,
  ProjectsAddParcelDetailsData,
  ProjectsAddParcelDetailsResponse,
  ProjectsCheckForSoilsRequestData,
  ProjectsCheckForSoilsRequestResponse,
  ProjectsCreateGeoItemData,
  ProjectsCreateGeoItemResponse,
  ProjectsDeleteFileData,
  ProjectsDeleteFileResponse,
  ProjectsDeleteGeoItemData,
  ProjectsDeleteGeoItemResponse,
  ProjectsEditGeoItemData,
  ProjectsEditGeoItemResponse,
  ProjectsFetchGeotechData,
  ProjectsFetchGeotechResponse,
  ProjectsGetProjectFeaturesData,
  ProjectsGetProjectFeaturesResponse,
  ProjectsGetStatePlaneZoneData,
  ProjectsGetStatePlaneZoneResponse,
  ProjectsGetZoningDataData,
  ProjectsGetZoningDataResponse,
  ProjectsListGeoItemsData,
  ProjectsListGeoItemsResponse,
  ProjectsParcelPointQueryData,
  ProjectsParcelPointQueryResponse,
  ProjectsPrintGeoItemData,
  ProjectsPrintGeoItemResponse,
  ProjectsPrintProjectPdfData,
  ProjectsPrintProjectPdfResponse,
  ProjectsRequestDataData,
  ProjectsRequestDataResponse,
  ProjectsSoilsRequestData,
  ProjectsSoilsRequestResponse,
  ProjectsUpdateFileData,
  ProjectsUpdateFileResponse,
  ProjectsV2AddCommentData,
  ProjectsV2AddCommentResponse,
  ProjectsV2AddIntelligenceCommentData,
  ProjectsV2AddIntelligenceCommentResponse,
  ProjectsV2AddMapData,
  ProjectsV2AddMapResponse,
  ProjectsV2AddMembersData,
  ProjectsV2AddMembersResponse,
  ProjectsV2AddObjectData,
  ProjectsV2AddObjectFileData,
  ProjectsV2AddObjectFileResponse,
  ProjectsV2AddObjectResponse,
  ProjectsV2AddObjectsData,
  ProjectsV2AddObjectsResponse,
  ProjectsV2AddProjectData,
  ProjectsV2AddProjectResponse,
  ProjectsV2ArchiveCommentData,
  ProjectsV2ArchiveCommentResponse,
  ProjectsV2ArchiveProjectData,
  ProjectsV2ArchiveProjectResponse,
  ProjectsV2DeleteIntelligenceCommentData,
  ProjectsV2DeleteIntelligenceCommentResponse,
  ProjectsV2DeleteMapData,
  ProjectsV2DeleteMapResponse,
  ProjectsV2DeleteObjectData,
  ProjectsV2DeleteObjectFilesData,
  ProjectsV2DeleteObjectFilesResponse,
  ProjectsV2DeleteObjectResponse,
  ProjectsV2DeletePermitData,
  ProjectsV2DeletePermitResponse,
  ProjectsV2DownloadCsAttachmentsData,
  ProjectsV2DownloadCsAttachmentsResponse,
  ProjectsV2DuplicateMapData,
  ProjectsV2DuplicateMapResponse,
  ProjectsV2EditProjectData,
  ProjectsV2EditProjectGeometryData,
  ProjectsV2EditProjectGeometryResponse,
  ProjectsV2EditProjectResponse,
  ProjectsV2ExportIntelligenceSummariesToExcelData,
  ProjectsV2ExportIntelligenceSummariesToExcelResponse,
  ProjectsV2GenerateEvidenceEmailChainData,
  ProjectsV2GenerateEvidenceEmailChainResponse,
  ProjectsV2GenerateFloodReportData,
  ProjectsV2GenerateFloodReportResponse,
  ProjectsV2GenerateProposalPacketData,
  ProjectsV2GenerateProposalPacketResponse,
  ProjectsV2GenerateRecordsResearchReportData,
  ProjectsV2GenerateRecordsResearchReportResponse,
  ProjectsV2GetAntennaDataData,
  ProjectsV2GetAntennaDataResponse,
  ProjectsV2GetCgsRegulatoryQuadrangleListData,
  ProjectsV2GetCgsRegulatoryQuadrangleListResponse,
  ProjectsV2GetCivilSearchActivitiesData,
  ProjectsV2GetCivilSearchActivitiesResponse,
  ProjectsV2GetCivilSearchMessagesData,
  ProjectsV2GetCivilSearchMessagesResponse,
  ProjectsV2GetDataRequestsV2Data,
  ProjectsV2GetDataRequestsV2Response,
  ProjectsV2GetDigitizationAccessData,
  ProjectsV2GetDigitizationAccessResponse,
  ProjectsV2GetDownloadRestrictionsData,
  ProjectsV2GetDownloadRestrictionsResponse,
  ProjectsV2GetDownloadSignedUrlData,
  ProjectsV2GetDownloadSignedUrlResponse,
  ProjectsV2GetEnvironmentalStudyDataData,
  ProjectsV2GetEnvironmentalStudyDataResponse,
  ProjectsV2GetEnvironmentalStudyPdfData,
  ProjectsV2GetEnvironmentalStudyPdfResponse,
  ProjectsV2GetEnvironmentalSummaryData,
  ProjectsV2GetEnvironmentalSummaryResponse,
  ProjectsV2GetGeotechnicalSummaryData,
  ProjectsV2GetGeotechnicalSummaryResponse,
  ProjectsV2GetHistoricalUsgsMapsData,
  ProjectsV2GetHistoricalUsgsMapsResponse,
  ProjectsV2GetIntelligenceFeaturesData,
  ProjectsV2GetIntelligenceFeaturesResponse,
  ProjectsV2GetLandRightsSummaryData,
  ProjectsV2GetLandRightsSummaryResponse,
  ProjectsV2GetLatestCivilSearchActivityData,
  ProjectsV2GetLatestCivilSearchActivityResponse,
  ProjectsV2GetLayersData,
  ProjectsV2GetLayersResponse,
  ProjectsV2GetMapData,
  ProjectsV2GetMapResponse,
  ProjectsV2GetParcelDataData,
  ProjectsV2GetParcelDataResponse,
  ProjectsV2GetPermitData,
  ProjectsV2GetPermitResponse,
  ProjectsV2GetProjectAgenciesData,
  ProjectsV2GetProjectAgenciesResponse,
  ProjectsV2GetProjectData,
  ProjectsV2GetProjectDownloadsData,
  ProjectsV2GetProjectDownloadsResponse,
  ProjectsV2GetProjectLayerAssetPresenceData,
  ProjectsV2GetProjectLayerAssetPresenceResponse,
  ProjectsV2GetProjectResponse,
  ProjectsV2GetStoredFileDownloadUrlData,
  ProjectsV2GetStoredFileDownloadUrlResponse,
  ProjectsV2GetUtilitiesFileSignedUrlData,
  ProjectsV2GetUtilitiesFileSignedUrlResponse,
  ProjectsV2GetUtilitiesSummaryData,
  ProjectsV2GetUtilitiesSummaryResponse,
  ProjectsV2GetUtilityAgenciesData,
  ProjectsV2GetUtilityAgenciesResponse,
  ProjectsV2JoinProjectData,
  ProjectsV2JoinProjectResponse,
  ProjectsV2LeaveProjectData,
  ProjectsV2LeaveProjectResponse,
  ProjectsV2ListIntelligenceSummariesData,
  ProjectsV2ListIntelligenceSummariesResponse,
  ProjectsV2ListMapsData,
  ProjectsV2ListMapsResponse,
  ProjectsV2ListProjectsV2Data,
  ProjectsV2ListProjectsV2Response,
  ProjectsV2ListTransactionsData,
  ProjectsV2ListTransactionsResponse,
  ProjectsV2NewCivilSearchMessageData,
  ProjectsV2NewCivilSearchMessageResponse,
  ProjectsV2PopulateProjectAgenciesDataData,
  ProjectsV2PopulateProjectAgenciesDataResponse,
  ProjectsV2PrintQuoteData,
  ProjectsV2PrintQuoteResponse,
  ProjectsV2PrintReceiptData,
  ProjectsV2PrintReceiptResponse,
  ProjectsV2RemoveMemberData,
  ProjectsV2RemoveMemberResponse,
  ProjectsV2RequestErisDataData,
  ProjectsV2RequestErisDataResponse,
  ProjectsV2SubmitDataRequestsV2Data,
  ProjectsV2SubmitDataRequestsV2Response,
  ProjectsV2SubmitDownloadRequestData,
  ProjectsV2SubmitDownloadRequestResponse,
  ProjectsV2UndoDeleteObjectData,
  ProjectsV2UndoDeleteObjectResponse,
  ProjectsV2UpdateBillingTierData,
  ProjectsV2UpdateBillingTierResponse,
  ProjectsV2UpdateCommentData,
  ProjectsV2UpdateCommentResponse,
  ProjectsV2UpdateIntelligenceStatusData,
  ProjectsV2UpdateIntelligenceStatusResponse,
  ProjectsV2UpdateIntelligenceSummaryData,
  ProjectsV2UpdateIntelligenceSummaryResponse,
  ProjectsV2UpdateMapData,
  ProjectsV2UpdateMapResponse,
  ProjectsV2UpdateObjectData,
  ProjectsV2UpdateObjectResponse,
  ProjectsV2UpdateUtilityNoteData,
  ProjectsV2UpdateUtilityNoteResponse,
  ProjectsV2UpsertPermitData,
  ProjectsV2UpsertPermitResponse,
  ProjectsV3AddShapefileCustomDataData,
  ProjectsV3AddShapefileCustomDataResponse,
  ProjectsV3AddWmtsCustomDataData,
  ProjectsV3AddWmtsCustomDataResponse,
  ProjectsV3BulkAddProjectBookmarksData,
  ProjectsV3BulkAddProjectBookmarksResponse,
  ProjectsV3BulkInviteMembersData,
  ProjectsV3BulkInviteMembersResponse,
  ProjectsV3BulkUpdateConstructionDatesData,
  ProjectsV3BulkUpdateConstructionDatesResponse,
  ProjectsV3BulkUpdatePlanStatusData,
  ProjectsV3BulkUpdatePlanStatusResponse,
  ProjectsV3BulkUpdateProjectsData,
  ProjectsV3BulkUpdateProjectsResponse,
  ProjectsV3DeleteCustomDataData,
  ProjectsV3DeleteCustomDataResponse,
  ProjectsV3DownloadCustomDataSourceData,
  ProjectsV3DownloadCustomDataSourceResponse,
  ProjectsV3ExportIntelligenceSummariesToExcelData,
  ProjectsV3ExportIntelligenceSummariesToExcelResponse,
  ProjectsV3ExportProjectsToExcelData,
  ProjectsV3ExportProjectsToExcelResponse,
  ProjectsV3GetIntelligenceSummaryMetaData,
  ProjectsV3GetIntelligenceSummaryMetaResponse,
  ProjectsV3GetProjectIntelligenceData,
  ProjectsV3GetProjectIntelligenceResponse,
  ProjectsV3GetSandboxProjectData,
  ProjectsV3GetSandboxProjectResponse,
  ProjectsV3InspectWmtsCustomDataData,
  ProjectsV3InspectWmtsCustomDataResponse,
  ProjectsV3InviteMembersData,
  ProjectsV3InviteMembersResponse,
  ProjectsV3ListAllProjectsData,
  ProjectsV3ListAllProjectsResponse,
  ProjectsV3ListCustomDataData,
  ProjectsV3ListCustomDataResponse,
  ProjectsV3ListGeoRefMapsForProjectData,
  ProjectsV3ListGeoRefMapsForProjectResponse,
  ProjectsV3ListIntelligenceSummariesData,
  ProjectsV3ListIntelligenceSummariesResponse,
  ProjectsV3ListProjectAgencyHistoryData,
  ProjectsV3ListProjectAgencyHistoryResponse,
  ProjectsV3ListProjectConnectbaseTasksData,
  ProjectsV3ListProjectConnectbaseTasksResponse,
  ProjectsV3ListProjectsData,
  ProjectsV3ListProjectsResponse,
  ProjectsV3SetCustomDataCategoriesData,
  ProjectsV3SetCustomDataCategoriesResponse,
  ProjectsV3SetCustomDataLabelData,
  ProjectsV3SetCustomDataLabelResponse,
  ProjectsV3SetCustomDataVisibilityData,
  ProjectsV3SetCustomDataVisibilityResponse,
  ProjectsV3ToggleProjectBookmarkData,
  ProjectsV3ToggleProjectBookmarkResponse,
  ReportProblemCreateData,
  ReportProblemCreateResponse,
  TileLayersListData,
  TileLayersListResponse,
  TitleGetDocumentByIdData,
  TitleGetDocumentByIdDownloadData,
  TitleGetDocumentByIdDownloadResponse,
  TitleGetDocumentByIdResponse,
  TitleGetDocumentsByIdsData,
  TitleGetDocumentsByIdsDownloadData,
  TitleGetDocumentsByIdsDownloadResponse,
  TitleGetDocumentsByIdsResponse,
  TitleGetParcelDetailsData,
  TitleGetParcelDetailsResponse,
  TitleGetReportDocsData,
  TitleGetReportDocsDownloadData,
  TitleGetReportDocsDownloadResponse,
  TitleGetReportDocsResponse,
  TitleGetTitleReportData,
  TitleGetTitleReportResponse,
  TitleOrderPrelimTitleReportData,
  TitleOrderPrelimTitleReportResponse,
  UploadsV3GetUploadData,
  UploadsV3GetUploadResponse,
  UploadsV3PresignUploadData,
  UploadsV3PresignUploadResponse,
  UploadsV3RegisterUploadData,
  UploadsV3RegisterUploadResponse,
  UserLayerConfigGetData,
  UserLayerConfigGetResponse,
  UserLayerConfigSeedData,
  UserLayerConfigSeedResponse,
  UserLayerConfigUpdateData,
  UserLayerConfigUpdateResponse,
  UsersCheckIfDomainAllowedData,
  UsersCheckIfDomainAllowedResponse,
  UsersCreateOrganizationData,
  UsersCreateOrganizationResponse,
  UsersFailedVerificationData,
  UsersFailedVerificationResponse,
  UsersGetMeData,
  UsersGetMeResponse,
  UsersSkipVerificationData,
  UsersSkipVerificationResponse,
  UsersUpdateProfileData,
  UsersUpdateProfileResponse,
  UsersUpdateProjectBookmarksData,
  UsersUpdateProjectBookmarksResponse,
  UsersUserCompletedVerificationData,
  UsersUserCompletedVerificationResponse,
  VerificationHandleWebhookData,
  VerificationHandleWebhookResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const healthTickQueryKey = (options?: Options<HealthTickData>) => createQueryKey('healthTick', options);

export const healthTickOptions = (options?: Options<HealthTickData>) =>
  queryOptions<HealthTickResponse, AxiosError<DefaultError>, HealthTickResponse, ReturnType<typeof healthTickQueryKey>>(
    {
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthTick({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: healthTickQueryKey(options),
    },
  );

export const authValidateTokenQueryKey = (options?: Options<AuthValidateTokenData>) =>
  createQueryKey('authValidateToken', options);

export const authValidateTokenOptions = (options?: Options<AuthValidateTokenData>) =>
  queryOptions<
    AuthValidateTokenResponse,
    AxiosError<DefaultError>,
    AuthValidateTokenResponse,
    ReturnType<typeof authValidateTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authValidateToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authValidateTokenQueryKey(options),
  });

export const availableLayersListQueryKey = (options: Options<AvailableLayersListData>) =>
  createQueryKey('availableLayersList', options);

export const availableLayersListOptions = (options: Options<AvailableLayersListData>) =>
  queryOptions<
    AvailableLayersListResponse,
    AxiosError<DefaultError>,
    AvailableLayersListResponse,
    ReturnType<typeof availableLayersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await availableLayersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: availableLayersListQueryKey(options),
  });

export const dataRefreshStatusListQueryKey = (options: Options<DataRefreshStatusListData>) =>
  createQueryKey('dataRefreshStatusList', options);

export const dataRefreshStatusListOptions = (options: Options<DataRefreshStatusListData>) =>
  queryOptions<
    DataRefreshStatusListResponse,
    AxiosError<DefaultError>,
    DataRefreshStatusListResponse,
    ReturnType<typeof dataRefreshStatusListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dataRefreshStatusList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dataRefreshStatusListQueryKey(options),
  });

export const drfSubmitRequestMutation = (
  options?: Partial<Options<DrfSubmitRequestData>>,
): UseMutationOptions<DrfSubmitRequestResponse, AxiosError<DefaultError>, Options<DrfSubmitRequestData>> => {
  const mutationOptions: UseMutationOptions<
    DrfSubmitRequestResponse,
    AxiosError<DefaultError>,
    Options<DrfSubmitRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfSubmitRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfUploadCeiiFileMutation = (
  options?: Partial<Options<DrfUploadCeiiFileData>>,
): UseMutationOptions<DrfUploadCeiiFileResponse, AxiosError<DefaultError>, Options<DrfUploadCeiiFileData>> => {
  const mutationOptions: UseMutationOptions<
    DrfUploadCeiiFileResponse,
    AxiosError<DefaultError>,
    Options<DrfUploadCeiiFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfUploadCeiiFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfListDrfRequestsQueryKey = (options: Options<DrfListDrfRequestsData>) =>
  createQueryKey('drfListDrfRequests', options);

export const drfListDrfRequestsOptions = (options: Options<DrfListDrfRequestsData>) =>
  queryOptions<
    DrfListDrfRequestsResponse,
    AxiosError<DefaultError>,
    DrfListDrfRequestsResponse,
    ReturnType<typeof drfListDrfRequestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await drfListDrfRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: drfListDrfRequestsQueryKey(options),
  });

export const drfUpdateDrfRequestMutation = (
  options?: Partial<Options<DrfUpdateDrfRequestData>>,
): UseMutationOptions<DrfUpdateDrfRequestResponse, AxiosError<DefaultError>, Options<DrfUpdateDrfRequestData>> => {
  const mutationOptions: UseMutationOptions<
    DrfUpdateDrfRequestResponse,
    AxiosError<DefaultError>,
    Options<DrfUpdateDrfRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfUpdateDrfRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfRegenerateApprovalPacketMutation = (
  options?: Partial<Options<DrfRegenerateApprovalPacketData>>,
): UseMutationOptions<
  DrfRegenerateApprovalPacketResponse,
  AxiosError<DefaultError>,
  Options<DrfRegenerateApprovalPacketData>
> => {
  const mutationOptions: UseMutationOptions<
    DrfRegenerateApprovalPacketResponse,
    AxiosError<DefaultError>,
    Options<DrfRegenerateApprovalPacketData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfRegenerateApprovalPacket({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfCreatePaymentIntentMutation = (
  options?: Partial<Options<DrfCreatePaymentIntentData>>,
): UseMutationOptions<
  DrfCreatePaymentIntentResponse,
  AxiosError<DefaultError>,
  Options<DrfCreatePaymentIntentData>
> => {
  const mutationOptions: UseMutationOptions<
    DrfCreatePaymentIntentResponse,
    AxiosError<DefaultError>,
    Options<DrfCreatePaymentIntentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfCreatePaymentIntent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfValidateGoogleRecaptchaMutation = (
  options?: Partial<Options<DrfValidateGoogleRecaptchaData>>,
): UseMutationOptions<
  DrfValidateGoogleRecaptchaResponse,
  AxiosError<DefaultError>,
  Options<DrfValidateGoogleRecaptchaData>
> => {
  const mutationOptions: UseMutationOptions<
    DrfValidateGoogleRecaptchaResponse,
    AxiosError<DefaultError>,
    Options<DrfValidateGoogleRecaptchaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfValidateGoogleRecaptcha({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfExportDrfTableToExcelMutation = (
  options?: Partial<Options<DrfExportDrfTableToExcelData>>,
): UseMutationOptions<
  DrfExportDrfTableToExcelResponse,
  AxiosError<DefaultError>,
  Options<DrfExportDrfTableToExcelData>
> => {
  const mutationOptions: UseMutationOptions<
    DrfExportDrfTableToExcelResponse,
    AxiosError<DefaultError>,
    Options<DrfExportDrfTableToExcelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drfExportDrfTableToExcel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drfGetDrfRequestActivitiesQueryKey = (options: Options<DrfGetDrfRequestActivitiesData>) =>
  createQueryKey('drfGetDrfRequestActivities', options);

export const drfGetDrfRequestActivitiesOptions = (options: Options<DrfGetDrfRequestActivitiesData>) =>
  queryOptions<
    DrfGetDrfRequestActivitiesResponse,
    AxiosError<DefaultError>,
    DrfGetDrfRequestActivitiesResponse,
    ReturnType<typeof drfGetDrfRequestActivitiesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await drfGetDrfRequestActivities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: drfGetDrfRequestActivitiesQueryKey(options),
  });

export const extractGetFiberRoutesQueryKey = (options?: Options<ExtractGetFiberRoutesData>) =>
  createQueryKey('extractGetFiberRoutes', options);

export const extractGetFiberRoutesOptions = (options?: Options<ExtractGetFiberRoutesData>) =>
  queryOptions<
    ExtractGetFiberRoutesResponse,
    AxiosError<DefaultError>,
    ExtractGetFiberRoutesResponse,
    ReturnType<typeof extractGetFiberRoutesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await extractGetFiberRoutes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: extractGetFiberRoutesQueryKey(options),
  });

export const extractGetFiberLitBuildingsQueryKey = (options?: Options<ExtractGetFiberLitBuildingsData>) =>
  createQueryKey('extractGetFiberLitBuildings', options);

export const extractGetFiberLitBuildingsOptions = (options?: Options<ExtractGetFiberLitBuildingsData>) =>
  queryOptions<
    ExtractGetFiberLitBuildingsResponse,
    AxiosError<DefaultError>,
    ExtractGetFiberLitBuildingsResponse,
    ReturnType<typeof extractGetFiberLitBuildingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await extractGetFiberLitBuildings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: extractGetFiberLitBuildingsQueryKey(options),
  });

export const extractGetExtractProjectionsQueryKey = (options: Options<ExtractGetExtractProjectionsData>) =>
  createQueryKey('extractGetExtractProjections', options);

export const extractGetExtractProjectionsOptions = (options: Options<ExtractGetExtractProjectionsData>) =>
  queryOptions<
    ExtractGetExtractProjectionsResponse,
    AxiosError<DefaultError>,
    ExtractGetExtractProjectionsResponse,
    ReturnType<typeof extractGetExtractProjectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await extractGetExtractProjections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: extractGetExtractProjectionsQueryKey(options),
  });

export const extractGetDefaultExtractProjectionQueryKey = (options: Options<ExtractGetDefaultExtractProjectionData>) =>
  createQueryKey('extractGetDefaultExtractProjection', options);

export const extractGetDefaultExtractProjectionOptions = (options: Options<ExtractGetDefaultExtractProjectionData>) =>
  queryOptions<
    ExtractGetDefaultExtractProjectionResponse,
    AxiosError<DefaultError>,
    ExtractGetDefaultExtractProjectionResponse,
    ReturnType<typeof extractGetDefaultExtractProjectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await extractGetDefaultExtractProjection({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: extractGetDefaultExtractProjectionQueryKey(options),
  });

export const extractNotifyExtractResultMutation = (
  options?: Partial<Options<ExtractNotifyExtractResultData>>,
): UseMutationOptions<
  ExtractNotifyExtractResultResponse,
  AxiosError<DefaultError>,
  Options<ExtractNotifyExtractResultData>
> => {
  const mutationOptions: UseMutationOptions<
    ExtractNotifyExtractResultResponse,
    AxiosError<DefaultError>,
    Options<ExtractNotifyExtractResultData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extractNotifyExtractResult({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const extractGetExtractResourcesQueryKey = (options?: Options<ExtractGetExtractResourcesData>) =>
  createQueryKey('extractGetExtractResources', options);

export const extractGetExtractResourcesOptions = (options?: Options<ExtractGetExtractResourcesData>) =>
  queryOptions<
    ExtractGetExtractResourcesResponse,
    AxiosError<DefaultError>,
    ExtractGetExtractResourcesResponse,
    ReturnType<typeof extractGetExtractResourcesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await extractGetExtractResources({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: extractGetExtractResourcesQueryKey(options),
  });

export const extractProjectExtractMutation = (
  options?: Partial<Options<ExtractProjectExtractData>>,
): UseMutationOptions<ExtractProjectExtractResponse, AxiosError<DefaultError>, Options<ExtractProjectExtractData>> => {
  const mutationOptions: UseMutationOptions<
    ExtractProjectExtractResponse,
    AxiosError<DefaultError>,
    Options<ExtractProjectExtractData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extractProjectExtract({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const extractGetOrganizationExtractTemplatesQueryKey = (
  options: Options<ExtractGetOrganizationExtractTemplatesData>,
) => createQueryKey('extractGetOrganizationExtractTemplates', options);

export const extractGetOrganizationExtractTemplatesOptions = (
  options: Options<ExtractGetOrganizationExtractTemplatesData>,
) =>
  queryOptions<
    ExtractGetOrganizationExtractTemplatesResponse,
    AxiosError<DefaultError>,
    ExtractGetOrganizationExtractTemplatesResponse,
    ReturnType<typeof extractGetOrganizationExtractTemplatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await extractGetOrganizationExtractTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: extractGetOrganizationExtractTemplatesQueryKey(options),
  });

export const internalGetAllOrganizationsQueryKey = (options?: Options<InternalGetAllOrganizationsData>) =>
  createQueryKey('internalGetAllOrganizations', options);

export const internalGetAllOrganizationsOptions = (options?: Options<InternalGetAllOrganizationsData>) =>
  queryOptions<
    InternalGetAllOrganizationsResponse,
    AxiosError<DefaultError>,
    InternalGetAllOrganizationsResponse,
    ReturnType<typeof internalGetAllOrganizationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetAllOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetAllOrganizationsQueryKey(options),
  });

export const internalGetSpecialDatasetSlugsQueryKey = (options?: Options<InternalGetSpecialDatasetSlugsData>) =>
  createQueryKey('internalGetSpecialDatasetSlugs', options);

export const internalGetSpecialDatasetSlugsOptions = (options?: Options<InternalGetSpecialDatasetSlugsData>) =>
  queryOptions<
    InternalGetSpecialDatasetSlugsResponse,
    AxiosError<DefaultError>,
    InternalGetSpecialDatasetSlugsResponse,
    ReturnType<typeof internalGetSpecialDatasetSlugsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetSpecialDatasetSlugs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetSpecialDatasetSlugsQueryKey(options),
  });

export const internalCreateOrganizationMutation = (
  options?: Partial<Options<InternalCreateOrganizationData>>,
): UseMutationOptions<
  InternalCreateOrganizationResponse,
  AxiosError<DefaultError>,
  Options<InternalCreateOrganizationData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCreateOrganizationResponse,
    AxiosError<DefaultError>,
    Options<InternalCreateOrganizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalCreateOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalCreateSandboxOrgMutation = (
  options?: Partial<Options<InternalCreateSandboxOrgData>>,
): UseMutationOptions<
  InternalCreateSandboxOrgResponse,
  AxiosError<DefaultError>,
  Options<InternalCreateSandboxOrgData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCreateSandboxOrgResponse,
    AxiosError<DefaultError>,
    Options<InternalCreateSandboxOrgData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalCreateSandboxOrg({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalAddTransactionMutation = (
  options?: Partial<Options<InternalAddTransactionData>>,
): UseMutationOptions<
  InternalAddTransactionResponse,
  AxiosError<DefaultError>,
  Options<InternalAddTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalAddTransactionResponse,
    AxiosError<DefaultError>,
    Options<InternalAddTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalAddTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetAllUsersQueryKey = (options?: Options<InternalGetAllUsersData>) =>
  createQueryKey('internalGetAllUsers', options);

export const internalGetAllUsersOptions = (options?: Options<InternalGetAllUsersData>) =>
  queryOptions<
    InternalGetAllUsersResponse,
    AxiosError<DefaultError>,
    InternalGetAllUsersResponse,
    ReturnType<typeof internalGetAllUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetAllUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetAllUsersQueryKey(options),
  });

export const internalGetInternalAdminUsersQueryKey = (options?: Options<InternalGetInternalAdminUsersData>) =>
  createQueryKey('internalGetInternalAdminUsers', options);

export const internalGetInternalAdminUsersOptions = (options?: Options<InternalGetInternalAdminUsersData>) =>
  queryOptions<
    InternalGetInternalAdminUsersResponse,
    AxiosError<DefaultError>,
    InternalGetInternalAdminUsersResponse,
    ReturnType<typeof internalGetInternalAdminUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetInternalAdminUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetInternalAdminUsersQueryKey(options),
  });

export const internalSetUserToOnboardedQueryKey = (options: Options<InternalSetUserToOnboardedData>) =>
  createQueryKey('internalSetUserToOnboarded', options);

export const internalSetUserToOnboardedOptions = (options: Options<InternalSetUserToOnboardedData>) =>
  queryOptions<
    InternalSetUserToOnboardedResponse,
    AxiosError<DefaultError>,
    InternalSetUserToOnboardedResponse,
    ReturnType<typeof internalSetUserToOnboardedQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSetUserToOnboarded({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalSetUserToOnboardedQueryKey(options),
  });

export const internalUpdateTelcoAccessQueryKey = (options: Options<InternalUpdateTelcoAccessData>) =>
  createQueryKey('internalUpdateTelcoAccess', options);

export const internalUpdateTelcoAccessOptions = (options: Options<InternalUpdateTelcoAccessData>) =>
  queryOptions<
    InternalUpdateTelcoAccessResponse,
    AxiosError<DefaultError>,
    InternalUpdateTelcoAccessResponse,
    ReturnType<typeof internalUpdateTelcoAccessQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalUpdateTelcoAccess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalUpdateTelcoAccessQueryKey(options),
  });

export const internalUpdateOrgPlanQueryKey = (options: Options<InternalUpdateOrgPlanData>) =>
  createQueryKey('internalUpdateOrgPlan', options);

export const internalUpdateOrgPlanOptions = (options: Options<InternalUpdateOrgPlanData>) =>
  queryOptions<
    InternalUpdateOrgPlanResponse,
    AxiosError<DefaultError>,
    InternalUpdateOrgPlanResponse,
    ReturnType<typeof internalUpdateOrgPlanQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalUpdateOrgPlan({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalUpdateOrgPlanQueryKey(options),
  });

export const internalSetUserToApprovedQueryKey = (options: Options<InternalSetUserToApprovedData>) =>
  createQueryKey('internalSetUserToApproved', options);

export const internalSetUserToApprovedOptions = (options: Options<InternalSetUserToApprovedData>) =>
  queryOptions<
    InternalSetUserToApprovedResponse,
    AxiosError<DefaultError>,
    InternalSetUserToApprovedResponse,
    ReturnType<typeof internalSetUserToApprovedQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSetUserToApproved({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalSetUserToApprovedQueryKey(options),
  });

export const internalPrintOrgInvoiceMutation = (
  options?: Partial<Options<InternalPrintOrgInvoiceData>>,
): UseMutationOptions<
  InternalPrintOrgInvoiceResponse,
  AxiosError<DefaultError>,
  Options<InternalPrintOrgInvoiceData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalPrintOrgInvoiceResponse,
    AxiosError<DefaultError>,
    Options<InternalPrintOrgInvoiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalPrintOrgInvoice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalToggleIsBillableQueryKey = (options: Options<InternalToggleIsBillableData>) =>
  createQueryKey('internalToggleIsBillable', options);

export const internalToggleIsBillableOptions = (options: Options<InternalToggleIsBillableData>) =>
  queryOptions<
    InternalToggleIsBillableResponse,
    AxiosError<DefaultError>,
    InternalToggleIsBillableResponse,
    ReturnType<typeof internalToggleIsBillableQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalToggleIsBillable({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalToggleIsBillableQueryKey(options),
  });

export const internalRunAgencyLoaderMutation = (
  options?: Partial<Options<InternalRunAgencyLoaderData>>,
): UseMutationOptions<
  InternalRunAgencyLoaderResponse,
  AxiosError<DefaultError>,
  Options<InternalRunAgencyLoaderData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalRunAgencyLoaderResponse,
    AxiosError<DefaultError>,
    Options<InternalRunAgencyLoaderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalRunAgencyLoader({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalClearEsriCacheMutation = (
  options?: Partial<Options<InternalClearEsriCacheData>>,
): UseMutationOptions<
  InternalClearEsriCacheResponse,
  AxiosError<DefaultError>,
  Options<InternalClearEsriCacheData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalClearEsriCacheResponse,
    AxiosError<DefaultError>,
    Options<InternalClearEsriCacheData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalClearEsriCache({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalRefreshTilesMutation = (
  options?: Partial<Options<InternalRefreshTilesData>>,
): UseMutationOptions<InternalRefreshTilesResponse, AxiosError<DefaultError>, Options<InternalRefreshTilesData>> => {
  const mutationOptions: UseMutationOptions<
    InternalRefreshTilesResponse,
    AxiosError<DefaultError>,
    Options<InternalRefreshTilesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalRefreshTiles({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalListOrgProjectsAsAdmQueryKey = (options: Options<InternalListOrgProjectsAsAdmData>) =>
  createQueryKey('internalListOrgProjectsAsAdm', options);

export const internalListOrgProjectsAsAdmOptions = (options: Options<InternalListOrgProjectsAsAdmData>) =>
  queryOptions<
    InternalListOrgProjectsAsAdmResponse,
    AxiosError<DefaultError>,
    InternalListOrgProjectsAsAdmResponse,
    ReturnType<typeof internalListOrgProjectsAsAdmQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalListOrgProjectsAsAdm({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalListOrgProjectsAsAdmQueryKey(options),
  });

export const internalComputeIntelligenceMutation = (
  options?: Partial<Options<InternalComputeIntelligenceData>>,
): UseMutationOptions<
  InternalComputeIntelligenceResponse,
  AxiosError<DefaultError>,
  Options<InternalComputeIntelligenceData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalComputeIntelligenceResponse,
    AxiosError<DefaultError>,
    Options<InternalComputeIntelligenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalComputeIntelligence({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalSyncIntelligenceMutation = (
  options?: Partial<Options<InternalSyncIntelligenceData>>,
): UseMutationOptions<
  InternalSyncIntelligenceResponse,
  AxiosError<DefaultError>,
  Options<InternalSyncIntelligenceData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSyncIntelligenceResponse,
    AxiosError<DefaultError>,
    Options<InternalSyncIntelligenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalSyncIntelligence({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetOrganizationSubscriptionsQueryKey = (
  options: Options<InternalGetOrganizationSubscriptionsData>,
) => createQueryKey('internalGetOrganizationSubscriptions', options);

export const internalGetOrganizationSubscriptionsOptions = (
  options: Options<InternalGetOrganizationSubscriptionsData>,
) =>
  queryOptions<
    InternalGetOrganizationSubscriptionsResponse,
    AxiosError<DefaultError>,
    InternalGetOrganizationSubscriptionsResponse,
    ReturnType<typeof internalGetOrganizationSubscriptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetOrganizationSubscriptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetOrganizationSubscriptionsQueryKey(options),
  });

export const internalGetOrganizationQueryKey = (options: Options<InternalGetOrganizationData>) =>
  createQueryKey('internalGetOrganization', options);

export const internalGetOrganizationOptions = (options: Options<InternalGetOrganizationData>) =>
  queryOptions<
    InternalGetOrganizationResponse,
    AxiosError<DefaultError>,
    InternalGetOrganizationResponse,
    ReturnType<typeof internalGetOrganizationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetOrganizationQueryKey(options),
  });

export const internalUpdateOrgSpecialDatasetsMutation = (
  options?: Partial<Options<InternalUpdateOrgSpecialDatasetsData>>,
): UseMutationOptions<
  InternalUpdateOrgSpecialDatasetsResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateOrgSpecialDatasetsData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateOrgSpecialDatasetsResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateOrgSpecialDatasetsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateOrgSpecialDatasets({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalUpdateOrgConnectbaseLookupMutation = (
  options?: Partial<Options<InternalUpdateOrgConnectbaseLookupData>>,
): UseMutationOptions<
  InternalUpdateOrgConnectbaseLookupResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateOrgConnectbaseLookupData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateOrgConnectbaseLookupResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateOrgConnectbaseLookupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateOrgConnectbaseLookup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetAdminTileLayersQueryKey = (options?: Options<InternalGetAdminTileLayersData>) =>
  createQueryKey('internalGetAdminTileLayers', options);

export const internalGetAdminTileLayersOptions = (options?: Options<InternalGetAdminTileLayersData>) =>
  queryOptions<
    InternalGetAdminTileLayersResponse,
    AxiosError<DefaultError>,
    InternalGetAdminTileLayersResponse,
    ReturnType<typeof internalGetAdminTileLayersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetAdminTileLayers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetAdminTileLayersQueryKey(options),
  });

export const internalUpdateDisabledTileLayersMutation = (
  options?: Partial<Options<InternalUpdateDisabledTileLayersData>>,
): UseMutationOptions<
  InternalUpdateDisabledTileLayersResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateDisabledTileLayersData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateDisabledTileLayersResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateDisabledTileLayersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateDisabledTileLayers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalLoadStagingLayerCatalogMutation = (
  options?: Partial<Options<InternalLoadStagingLayerCatalogData>>,
): UseMutationOptions<
  InternalLoadStagingLayerCatalogResponse,
  AxiosError<DefaultError>,
  Options<InternalLoadStagingLayerCatalogData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLoadStagingLayerCatalogResponse,
    AxiosError<DefaultError>,
    Options<InternalLoadStagingLayerCatalogData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalLoadStagingLayerCatalog({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalJoinOrgAsAdminMutation = (
  options?: Partial<Options<InternalJoinOrgAsAdminData>>,
): UseMutationOptions<
  InternalJoinOrgAsAdminResponse,
  AxiosError<DefaultError>,
  Options<InternalJoinOrgAsAdminData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalJoinOrgAsAdminResponse,
    AxiosError<DefaultError>,
    Options<InternalJoinOrgAsAdminData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalJoinOrgAsAdmin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalTriggerDigestForProjectMutation = (
  options?: Partial<Options<InternalTriggerDigestForProjectData>>,
): UseMutationOptions<
  InternalTriggerDigestForProjectResponse,
  AxiosError<DefaultError>,
  Options<InternalTriggerDigestForProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTriggerDigestForProjectResponse,
    AxiosError<DefaultError>,
    Options<InternalTriggerDigestForProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalTriggerDigestForProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalUpdateOrganizationSubscriptionMutation = (
  options?: Partial<Options<InternalUpdateOrganizationSubscriptionData>>,
): UseMutationOptions<
  InternalUpdateOrganizationSubscriptionResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateOrganizationSubscriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateOrganizationSubscriptionResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateOrganizationSubscriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateOrganizationSubscription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalUpdateLinkedOrganizationsMutation = (
  options?: Partial<Options<InternalUpdateLinkedOrganizationsData>>,
): UseMutationOptions<
  InternalUpdateLinkedOrganizationsResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateLinkedOrganizationsData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateLinkedOrganizationsResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateLinkedOrganizationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateLinkedOrganizations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalPromoteGisConfigMutation = (
  options?: Partial<Options<InternalPromoteGisConfigData>>,
): UseMutationOptions<
  InternalPromoteGisConfigResponse,
  AxiosError<DefaultError>,
  Options<InternalPromoteGisConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalPromoteGisConfigResponse,
    AxiosError<DefaultError>,
    Options<InternalPromoteGisConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalPromoteGisConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalRefreshTileConfigMutation = (
  options?: Partial<Options<InternalRefreshTileConfigData>>,
): UseMutationOptions<
  InternalRefreshTileConfigResponse,
  AxiosError<DefaultError>,
  Options<InternalRefreshTileConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalRefreshTileConfigResponse,
    AxiosError<DefaultError>,
    Options<InternalRefreshTileConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalRefreshTileConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetPgeCloudSyncFoldersQueryKey = (options?: Options<InternalGetPgeCloudSyncFoldersData>) =>
  createQueryKey('internalGetPgeCloudSyncFolders', options);

export const internalGetPgeCloudSyncFoldersOptions = (options?: Options<InternalGetPgeCloudSyncFoldersData>) =>
  queryOptions<
    InternalGetPgeCloudSyncFoldersResponse,
    AxiosError<DefaultError>,
    InternalGetPgeCloudSyncFoldersResponse,
    ReturnType<typeof internalGetPgeCloudSyncFoldersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetPgeCloudSyncFolders({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetPgeCloudSyncFoldersQueryKey(options),
  });

export const internalTriggerPgeCloudSyncWorkflowMutation = (
  options?: Partial<Options<InternalTriggerPgeCloudSyncWorkflowData>>,
): UseMutationOptions<
  InternalTriggerPgeCloudSyncWorkflowResponse,
  AxiosError<DefaultError>,
  Options<InternalTriggerPgeCloudSyncWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTriggerPgeCloudSyncWorkflowResponse,
    AxiosError<DefaultError>,
    Options<InternalTriggerPgeCloudSyncWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalTriggerPgeCloudSyncWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetSubscriptionsStatusQueryKey = (options?: Options<InternalGetSubscriptionsStatusData>) =>
  createQueryKey('internalGetSubscriptionsStatus', options);

export const internalGetSubscriptionsStatusOptions = (options?: Options<InternalGetSubscriptionsStatusData>) =>
  queryOptions<
    InternalGetSubscriptionsStatusResponse,
    AxiosError<DefaultError>,
    InternalGetSubscriptionsStatusResponse,
    ReturnType<typeof internalGetSubscriptionsStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetSubscriptionsStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetSubscriptionsStatusQueryKey(options),
  });

export const internalUpdateSubscriptionContractEndsOnMutation = (
  options?: Partial<Options<InternalUpdateSubscriptionContractEndsOnData>>,
): UseMutationOptions<
  InternalUpdateSubscriptionContractEndsOnResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateSubscriptionContractEndsOnData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateSubscriptionContractEndsOnResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateSubscriptionContractEndsOnData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateSubscriptionContractEndsOn({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalUpdateOrganizationAccountTypeMutation = (
  options?: Partial<Options<InternalUpdateOrganizationAccountTypeData>>,
): UseMutationOptions<
  InternalUpdateOrganizationAccountTypeResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateOrganizationAccountTypeData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateOrganizationAccountTypeResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateOrganizationAccountTypeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateOrganizationAccountType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetDemoOrgsQueryKey = (options?: Options<InternalGetDemoOrgsData>) =>
  createQueryKey('internalGetDemoOrgs', options);

export const internalGetDemoOrgsOptions = (options?: Options<InternalGetDemoOrgsData>) =>
  queryOptions<
    InternalGetDemoOrgsResponse,
    AxiosError<DefaultError>,
    InternalGetDemoOrgsResponse,
    ReturnType<typeof internalGetDemoOrgsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetDemoOrgs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetDemoOrgsQueryKey(options),
  });

export const internalResetDemoOrgMutation = (
  options?: Partial<Options<InternalResetDemoOrgData>>,
): UseMutationOptions<InternalResetDemoOrgResponse, AxiosError<DefaultError>, Options<InternalResetDemoOrgData>> => {
  const mutationOptions: UseMutationOptions<
    InternalResetDemoOrgResponse,
    AxiosError<DefaultError>,
    Options<InternalResetDemoOrgData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalResetDemoOrg({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalSyncExtractProjectionsMutation = (
  options?: Partial<Options<InternalSyncExtractProjectionsData>>,
): UseMutationOptions<
  InternalSyncExtractProjectionsResponse,
  AxiosError<DefaultError>,
  Options<InternalSyncExtractProjectionsData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSyncExtractProjectionsResponse,
    AxiosError<DefaultError>,
    Options<InternalSyncExtractProjectionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalSyncExtractProjections({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalCreateExtractAutomationMutation = (
  options?: Partial<Options<InternalCreateExtractAutomationData>>,
): UseMutationOptions<
  InternalCreateExtractAutomationResponse,
  AxiosError<DefaultError>,
  Options<InternalCreateExtractAutomationData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCreateExtractAutomationResponse,
    AxiosError<DefaultError>,
    Options<InternalCreateExtractAutomationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalCreateExtractAutomation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalActivateExtractAutomationMutation = (
  options?: Partial<Options<InternalActivateExtractAutomationData>>,
): UseMutationOptions<
  InternalActivateExtractAutomationResponse,
  AxiosError<DefaultError>,
  Options<InternalActivateExtractAutomationData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalActivateExtractAutomationResponse,
    AxiosError<DefaultError>,
    Options<InternalActivateExtractAutomationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalActivateExtractAutomation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalDeleteExtractAutomationMutation = (
  options?: Partial<Options<InternalDeleteExtractAutomationData>>,
): UseMutationOptions<
  InternalDeleteExtractAutomationResponse,
  AxiosError<DefaultError>,
  Options<InternalDeleteExtractAutomationData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalDeleteExtractAutomationResponse,
    AxiosError<DefaultError>,
    Options<InternalDeleteExtractAutomationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalDeleteExtractAutomation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalCreateExtractTemplateMutation = (
  options?: Partial<Options<InternalCreateExtractTemplateData>>,
): UseMutationOptions<
  InternalCreateExtractTemplateResponse,
  AxiosError<DefaultError>,
  Options<InternalCreateExtractTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCreateExtractTemplateResponse,
    AxiosError<DefaultError>,
    Options<InternalCreateExtractTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalCreateExtractTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalAssignExtractTemplateMutation = (
  options?: Partial<Options<InternalAssignExtractTemplateData>>,
): UseMutationOptions<
  InternalAssignExtractTemplateResponse,
  AxiosError<DefaultError>,
  Options<InternalAssignExtractTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalAssignExtractTemplateResponse,
    AxiosError<DefaultError>,
    Options<InternalAssignExtractTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalAssignExtractTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetExtractAdminStateQueryKey = (options?: Options<InternalGetExtractAdminStateData>) =>
  createQueryKey('internalGetExtractAdminState', options);

export const internalGetExtractAdminStateOptions = (options?: Options<InternalGetExtractAdminStateData>) =>
  queryOptions<
    InternalGetExtractAdminStateResponse,
    AxiosError<DefaultError>,
    InternalGetExtractAdminStateResponse,
    ReturnType<typeof internalGetExtractAdminStateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetExtractAdminState({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetExtractAdminStateQueryKey(options),
  });

export const internalListExportEscalationsQueryKey = (options?: Options<InternalListExportEscalationsData>) =>
  createQueryKey('internalListExportEscalations', options);

export const internalListExportEscalationsOptions = (options?: Options<InternalListExportEscalationsData>) =>
  queryOptions<
    InternalListExportEscalationsResponse,
    AxiosError<DefaultError>,
    InternalListExportEscalationsResponse,
    ReturnType<typeof internalListExportEscalationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalListExportEscalations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalListExportEscalationsQueryKey(options),
  });

export const internalGetExportEscalationQueryKey = (options: Options<InternalGetExportEscalationData>) =>
  createQueryKey('internalGetExportEscalation', options);

export const internalGetExportEscalationOptions = (options: Options<InternalGetExportEscalationData>) =>
  queryOptions<
    InternalGetExportEscalationResponse,
    AxiosError<DefaultError>,
    InternalGetExportEscalationResponse,
    ReturnType<typeof internalGetExportEscalationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetExportEscalation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetExportEscalationQueryKey(options),
  });

export const internalUpdateExportEscalationNotesMutation = (
  options?: Partial<Options<InternalUpdateExportEscalationNotesData>>,
): UseMutationOptions<
  InternalUpdateExportEscalationNotesResponse,
  AxiosError<DefaultError>,
  Options<InternalUpdateExportEscalationNotesData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalUpdateExportEscalationNotesResponse,
    AxiosError<DefaultError>,
    Options<InternalUpdateExportEscalationNotesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalUpdateExportEscalationNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalArchiveExportEscalationMutation = (
  options?: Partial<Options<InternalArchiveExportEscalationData>>,
): UseMutationOptions<
  InternalArchiveExportEscalationResponse,
  AxiosError<DefaultError>,
  Options<InternalArchiveExportEscalationData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalArchiveExportEscalationResponse,
    AxiosError<DefaultError>,
    Options<InternalArchiveExportEscalationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalArchiveExportEscalation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalRunExportEscalationMutation = (
  options?: Partial<Options<InternalRunExportEscalationData>>,
): UseMutationOptions<
  InternalRunExportEscalationResponse,
  AxiosError<DefaultError>,
  Options<InternalRunExportEscalationData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalRunExportEscalationResponse,
    AxiosError<DefaultError>,
    Options<InternalRunExportEscalationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalRunExportEscalation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalRestoreGeoItemRevisionMutation = (
  options?: Partial<Options<InternalRestoreGeoItemRevisionData>>,
): UseMutationOptions<
  InternalRestoreGeoItemRevisionResponse,
  AxiosError<DefaultError>,
  Options<InternalRestoreGeoItemRevisionData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalRestoreGeoItemRevisionResponse,
    AxiosError<DefaultError>,
    Options<InternalRestoreGeoItemRevisionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalRestoreGeoItemRevision({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const userLayerConfigSeedMutation = (
  options?: Partial<Options<UserLayerConfigSeedData>>,
): UseMutationOptions<UserLayerConfigSeedResponse, AxiosError<DefaultError>, Options<UserLayerConfigSeedData>> => {
  const mutationOptions: UseMutationOptions<
    UserLayerConfigSeedResponse,
    AxiosError<DefaultError>,
    Options<UserLayerConfigSeedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userLayerConfigSeed({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const userLayerConfigGetQueryKey = (options: Options<UserLayerConfigGetData>) =>
  createQueryKey('userLayerConfigGet', options);

export const userLayerConfigGetOptions = (options: Options<UserLayerConfigGetData>) =>
  queryOptions<
    UserLayerConfigGetResponse,
    AxiosError<DefaultError>,
    UserLayerConfigGetResponse,
    ReturnType<typeof userLayerConfigGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userLayerConfigGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userLayerConfigGetQueryKey(options),
  });

export const userLayerConfigUpdateMutation = (
  options?: Partial<Options<UserLayerConfigUpdateData>>,
): UseMutationOptions<UserLayerConfigUpdateResponse, AxiosError<DefaultError>, Options<UserLayerConfigUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    UserLayerConfigUpdateResponse,
    AxiosError<DefaultError>,
    Options<UserLayerConfigUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userLayerConfigUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const miscGet811DataQueryKey = (options?: Options<MiscGet811DataData>) =>
  createQueryKey('miscGet811Data', options);

export const miscGet811DataOptions = (options?: Options<MiscGet811DataData>) =>
  queryOptions<
    MiscGet811DataResponse,
    AxiosError<DefaultError>,
    MiscGet811DataResponse,
    ReturnType<typeof miscGet811DataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await miscGet811Data({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: miscGet811DataQueryKey(options),
  });

export const miscLogEventMutation = (
  options?: Partial<Options<MiscLogEventData>>,
): UseMutationOptions<MiscLogEventResponse, AxiosError<DefaultError>, Options<MiscLogEventData>> => {
  const mutationOptions: UseMutationOptions<
    MiscLogEventResponse,
    AxiosError<DefaultError>,
    Options<MiscLogEventData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await miscLogEvent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const miscCalculateWatershedRiskQueryKey = (options: Options<MiscCalculateWatershedRiskData>) =>
  createQueryKey('miscCalculateWatershedRisk', options);

export const miscCalculateWatershedRiskOptions = (options: Options<MiscCalculateWatershedRiskData>) =>
  queryOptions<
    MiscCalculateWatershedRiskResponse,
    AxiosError<DefaultError>,
    MiscCalculateWatershedRiskResponse,
    ReturnType<typeof miscCalculateWatershedRiskQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await miscCalculateWatershedRisk({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: miscCalculateWatershedRiskQueryKey(options),
  });

export const mobileVersionGetQueryKey = (options?: Options<MobileVersionGetData>) =>
  createQueryKey('mobileVersionGet', options);

export const mobileVersionGetOptions = (options?: Options<MobileVersionGetData>) =>
  queryOptions<
    MobileVersionGetResponse,
    AxiosError<DefaultError>,
    MobileVersionGetResponse,
    ReturnType<typeof mobileVersionGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mobileVersionGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: mobileVersionGetQueryKey(options),
  });

export const mobileVersionUpdateMutation = (
  options?: Partial<Options<MobileVersionUpdateData>>,
): UseMutationOptions<MobileVersionUpdateResponse, AxiosError<DefaultError>, Options<MobileVersionUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    MobileVersionUpdateResponse,
    AxiosError<DefaultError>,
    Options<MobileVersionUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mobileVersionUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsGetMyOrganizationsQueryKey = (options?: Options<OrganizationsGetMyOrganizationsData>) =>
  createQueryKey('organizationsGetMyOrganizations', options);

export const organizationsGetMyOrganizationsOptions = (options?: Options<OrganizationsGetMyOrganizationsData>) =>
  queryOptions<
    OrganizationsGetMyOrganizationsResponse,
    AxiosError<DefaultError>,
    OrganizationsGetMyOrganizationsResponse,
    ReturnType<typeof organizationsGetMyOrganizationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsGetMyOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationsGetMyOrganizationsQueryKey(options),
  });

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const organizationsGetMyOrganizationsInfiniteQueryKey = (
  options?: Options<OrganizationsGetMyOrganizationsData>,
): QueryKey<Options<OrganizationsGetMyOrganizationsData>> =>
  createQueryKey('organizationsGetMyOrganizations', options, true);

export const organizationsGetMyOrganizationsInfiniteOptions = (
  options?: Options<OrganizationsGetMyOrganizationsData>,
) => {
  const opts = infiniteQueryOptions<
    OrganizationsGetMyOrganizationsResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsGetMyOrganizationsResponse>,
    QueryKey<Options<OrganizationsGetMyOrganizationsData>>,
    string | Pick<QueryKey<Options<OrganizationsGetMyOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsGetMyOrganizationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await organizationsGetMyOrganizations({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: organizationsGetMyOrganizationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const organizationsGetQueryKey = (options: Options<OrganizationsGetData>) =>
  createQueryKey('organizationsGet', options);

export const organizationsGetOptions = (options: Options<OrganizationsGetData>) =>
  queryOptions<
    OrganizationsGetResponse,
    AxiosError<DefaultError>,
    OrganizationsGetResponse,
    ReturnType<typeof organizationsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationsGetQueryKey(options),
  });

export const organizationsEditMutation = (
  options?: Partial<Options<OrganizationsEditData>>,
): UseMutationOptions<OrganizationsEditResponse, AxiosError<DefaultError>, Options<OrganizationsEditData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsEditResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsEditData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsEdit({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsGetMembersQueryKey = (options: Options<OrganizationsGetMembersData>) =>
  createQueryKey('organizationsGetMembers', options);

export const organizationsGetMembersOptions = (options: Options<OrganizationsGetMembersData>) =>
  queryOptions<
    OrganizationsGetMembersResponse,
    AxiosError<DefaultError>,
    OrganizationsGetMembersResponse,
    ReturnType<typeof organizationsGetMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsGetMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationsGetMembersQueryKey(options),
  });

export const organizationsAddMembersMutation = (
  options?: Partial<Options<OrganizationsAddMembersData>>,
): UseMutationOptions<
  OrganizationsAddMembersResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAddMembersData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAddMembersResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAddMembersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAddMembers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsEditMemberMutation = (
  options?: Partial<Options<OrganizationsEditMemberData>>,
): UseMutationOptions<
  OrganizationsEditMemberResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsEditMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsEditMemberResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsEditMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsEditMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsEditRoleMutation = (
  options?: Partial<Options<OrganizationsEditRoleData>>,
): UseMutationOptions<OrganizationsEditRoleResponse, AxiosError<DefaultError>, Options<OrganizationsEditRoleData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsEditRoleResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsEditRoleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsEditRole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsResendInviteQueryKey = (options: Options<OrganizationsResendInviteData>) =>
  createQueryKey('organizationsResendInvite', options);

export const organizationsResendInviteOptions = (options: Options<OrganizationsResendInviteData>) =>
  queryOptions<
    OrganizationsResendInviteResponse,
    AxiosError<DefaultError>,
    OrganizationsResendInviteResponse,
    ReturnType<typeof organizationsResendInviteQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsResendInvite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationsResendInviteQueryKey(options),
  });

export const organizationsAddFileMutation = (
  options?: Partial<Options<OrganizationsAddFileData>>,
): UseMutationOptions<OrganizationsAddFileResponse, AxiosError<DefaultError>, Options<OrganizationsAddFileData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAddFileResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAddFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAddFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsGetOrgSummaryQueryKey = (options: Options<OrganizationsGetOrgSummaryData>) =>
  createQueryKey('organizationsGetOrgSummary', options);

export const organizationsGetOrgSummaryOptions = (options: Options<OrganizationsGetOrgSummaryData>) =>
  queryOptions<
    OrganizationsGetOrgSummaryResponse,
    AxiosError<DefaultError>,
    OrganizationsGetOrgSummaryResponse,
    ReturnType<typeof organizationsGetOrgSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsGetOrgSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationsGetOrgSummaryQueryKey(options),
  });

export const organizationsGetBillingSummaryQueryKey = (options: Options<OrganizationsGetBillingSummaryData>) =>
  createQueryKey('organizationsGetBillingSummary', options);

export const organizationsGetBillingSummaryOptions = (options: Options<OrganizationsGetBillingSummaryData>) =>
  queryOptions<
    OrganizationsGetBillingSummaryResponse,
    AxiosError<DefaultError>,
    OrganizationsGetBillingSummaryResponse,
    ReturnType<typeof organizationsGetBillingSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsGetBillingSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationsGetBillingSummaryQueryKey(options),
  });

export const organizationsPrintBillingSummaryMutation = (
  options?: Partial<Options<OrganizationsPrintBillingSummaryData>>,
): UseMutationOptions<
  OrganizationsPrintBillingSummaryResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsPrintBillingSummaryData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsPrintBillingSummaryResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsPrintBillingSummaryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsPrintBillingSummary({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationsSetTestEnvOverrideMutation = (
  options?: Partial<Options<OrganizationsSetTestEnvOverrideData>>,
): UseMutationOptions<
  OrganizationsSetTestEnvOverrideResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsSetTestEnvOverrideData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsSetTestEnvOverrideResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsSetTestEnvOverrideData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsSetTestEnvOverride({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgLayerConfigGetQueryKey = (options: Options<OrgLayerConfigGetData>) =>
  createQueryKey('orgLayerConfigGet', options);

export const orgLayerConfigGetOptions = (options: Options<OrgLayerConfigGetData>) =>
  queryOptions<
    OrgLayerConfigGetResponse,
    AxiosError<DefaultError>,
    OrgLayerConfigGetResponse,
    ReturnType<typeof orgLayerConfigGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgLayerConfigGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgLayerConfigGetQueryKey(options),
  });

export const orgLayerConfigUpdateMutation = (
  options?: Partial<Options<OrgLayerConfigUpdateData>>,
): UseMutationOptions<OrgLayerConfigUpdateResponse, AxiosError<DefaultError>, Options<OrgLayerConfigUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    OrgLayerConfigUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrgLayerConfigUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgLayerConfigUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const preferencesUpdateProjectMemberNotificationsMutation = (
  options?: Partial<Options<PreferencesUpdateProjectMemberNotificationsData>>,
): UseMutationOptions<
  PreferencesUpdateProjectMemberNotificationsResponse,
  AxiosError<DefaultError>,
  Options<PreferencesUpdateProjectMemberNotificationsData>
> => {
  const mutationOptions: UseMutationOptions<
    PreferencesUpdateProjectMemberNotificationsResponse,
    AxiosError<DefaultError>,
    Options<PreferencesUpdateProjectMemberNotificationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await preferencesUpdateProjectMemberNotifications({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsAddFileMutation = (
  options?: Partial<Options<ProjectsAddFileData>>,
): UseMutationOptions<ProjectsAddFileResponse, AxiosError<DefaultError>, Options<ProjectsAddFileData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsAddFileResponse,
    AxiosError<DefaultError>,
    Options<ProjectsAddFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsAddFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsDeleteFileMutation = (
  options?: Partial<Options<ProjectsDeleteFileData>>,
): UseMutationOptions<ProjectsDeleteFileResponse, AxiosError<DefaultError>, Options<ProjectsDeleteFileData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsDeleteFileResponse,
    AxiosError<DefaultError>,
    Options<ProjectsDeleteFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsDeleteFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsUpdateFileMutation = (
  options?: Partial<Options<ProjectsUpdateFileData>>,
): UseMutationOptions<ProjectsUpdateFileResponse, AxiosError<DefaultError>, Options<ProjectsUpdateFileData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsUpdateFileResponse,
    AxiosError<DefaultError>,
    Options<ProjectsUpdateFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsUpdateFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsAddParcelDetailsMutation = (
  options?: Partial<Options<ProjectsAddParcelDetailsData>>,
): UseMutationOptions<
  ProjectsAddParcelDetailsResponse,
  AxiosError<DefaultError>,
  Options<ProjectsAddParcelDetailsData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsAddParcelDetailsResponse,
    AxiosError<DefaultError>,
    Options<ProjectsAddParcelDetailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsAddParcelDetails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsRequestDataMutation = (
  options?: Partial<Options<ProjectsRequestDataData>>,
): UseMutationOptions<ProjectsRequestDataResponse, AxiosError<DefaultError>, Options<ProjectsRequestDataData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsRequestDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsRequestDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsRequestData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsFetchGeotechMutation = (
  options?: Partial<Options<ProjectsFetchGeotechData>>,
): UseMutationOptions<ProjectsFetchGeotechResponse, AxiosError<DefaultError>, Options<ProjectsFetchGeotechData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsFetchGeotechResponse,
    AxiosError<DefaultError>,
    Options<ProjectsFetchGeotechData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsFetchGeotech({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsCheckForSoilsRequestQueryKey = (options: Options<ProjectsCheckForSoilsRequestData>) =>
  createQueryKey('projectsCheckForSoilsRequest', options);

export const projectsCheckForSoilsRequestOptions = (options: Options<ProjectsCheckForSoilsRequestData>) =>
  queryOptions<
    ProjectsCheckForSoilsRequestResponse,
    AxiosError<DefaultError>,
    ProjectsCheckForSoilsRequestResponse,
    ReturnType<typeof projectsCheckForSoilsRequestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsCheckForSoilsRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsCheckForSoilsRequestQueryKey(options),
  });

export const projectsSoilsRequestMutation = (
  options?: Partial<Options<ProjectsSoilsRequestData>>,
): UseMutationOptions<ProjectsSoilsRequestResponse, AxiosError<DefaultError>, Options<ProjectsSoilsRequestData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsSoilsRequestResponse,
    AxiosError<DefaultError>,
    Options<ProjectsSoilsRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsSoilsRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsListGeoItemsQueryKey = (options: Options<ProjectsListGeoItemsData>) =>
  createQueryKey('projectsListGeoItems', options);

export const projectsListGeoItemsOptions = (options: Options<ProjectsListGeoItemsData>) =>
  queryOptions<
    ProjectsListGeoItemsResponse,
    AxiosError<DefaultError>,
    ProjectsListGeoItemsResponse,
    ReturnType<typeof projectsListGeoItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsListGeoItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsListGeoItemsQueryKey(options),
  });

export const projectsCreateGeoItemMutation = (
  options?: Partial<Options<ProjectsCreateGeoItemData>>,
): UseMutationOptions<ProjectsCreateGeoItemResponse, AxiosError<DefaultError>, Options<ProjectsCreateGeoItemData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsCreateGeoItemResponse,
    AxiosError<DefaultError>,
    Options<ProjectsCreateGeoItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsCreateGeoItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsDeleteGeoItemMutation = (
  options?: Partial<Options<ProjectsDeleteGeoItemData>>,
): UseMutationOptions<ProjectsDeleteGeoItemResponse, AxiosError<DefaultError>, Options<ProjectsDeleteGeoItemData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsDeleteGeoItemResponse,
    AxiosError<DefaultError>,
    Options<ProjectsDeleteGeoItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsDeleteGeoItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsEditGeoItemMutation = (
  options?: Partial<Options<ProjectsEditGeoItemData>>,
): UseMutationOptions<ProjectsEditGeoItemResponse, AxiosError<DefaultError>, Options<ProjectsEditGeoItemData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsEditGeoItemResponse,
    AxiosError<DefaultError>,
    Options<ProjectsEditGeoItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsEditGeoItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsPrintGeoItemMutation = (
  options?: Partial<Options<ProjectsPrintGeoItemData>>,
): UseMutationOptions<ProjectsPrintGeoItemResponse, AxiosError<DefaultError>, Options<ProjectsPrintGeoItemData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsPrintGeoItemResponse,
    AxiosError<DefaultError>,
    Options<ProjectsPrintGeoItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsPrintGeoItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsPrintProjectPdfMutation = (
  options?: Partial<Options<ProjectsPrintProjectPdfData>>,
): UseMutationOptions<
  ProjectsPrintProjectPdfResponse,
  AxiosError<DefaultError>,
  Options<ProjectsPrintProjectPdfData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsPrintProjectPdfResponse,
    AxiosError<DefaultError>,
    Options<ProjectsPrintProjectPdfData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsPrintProjectPdf({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsGetZoningDataQueryKey = (options: Options<ProjectsGetZoningDataData>) =>
  createQueryKey('projectsGetZoningData', options);

export const projectsGetZoningDataOptions = (options: Options<ProjectsGetZoningDataData>) =>
  queryOptions<
    ProjectsGetZoningDataResponse,
    AxiosError<DefaultError>,
    ProjectsGetZoningDataResponse,
    ReturnType<typeof projectsGetZoningDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsGetZoningData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsGetZoningDataQueryKey(options),
  });

export const projectsParcelPointQueryQueryKey = (options: Options<ProjectsParcelPointQueryData>) =>
  createQueryKey('projectsParcelPointQuery', options);

export const projectsParcelPointQueryOptions = (options: Options<ProjectsParcelPointQueryData>) =>
  queryOptions<
    ProjectsParcelPointQueryResponse,
    AxiosError<DefaultError>,
    ProjectsParcelPointQueryResponse,
    ReturnType<typeof projectsParcelPointQueryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsParcelPointQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsParcelPointQueryQueryKey(options),
  });

export const projectsGetStatePlaneZoneQueryKey = (options: Options<ProjectsGetStatePlaneZoneData>) =>
  createQueryKey('projectsGetStatePlaneZone', options);

export const projectsGetStatePlaneZoneOptions = (options: Options<ProjectsGetStatePlaneZoneData>) =>
  queryOptions<
    ProjectsGetStatePlaneZoneResponse,
    AxiosError<DefaultError>,
    ProjectsGetStatePlaneZoneResponse,
    ReturnType<typeof projectsGetStatePlaneZoneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsGetStatePlaneZone({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsGetStatePlaneZoneQueryKey(options),
  });

export const projectsGetProjectFeaturesQueryKey = (options: Options<ProjectsGetProjectFeaturesData>) =>
  createQueryKey('projectsGetProjectFeatures', options);

export const projectsGetProjectFeaturesOptions = (options: Options<ProjectsGetProjectFeaturesData>) =>
  queryOptions<
    ProjectsGetProjectFeaturesResponse,
    AxiosError<DefaultError>,
    ProjectsGetProjectFeaturesResponse,
    ReturnType<typeof projectsGetProjectFeaturesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsGetProjectFeatures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsGetProjectFeaturesQueryKey(options),
  });

export const reportProblemCreateMutation = (
  options?: Partial<Options<ReportProblemCreateData>>,
): UseMutationOptions<ReportProblemCreateResponse, AxiosError<DefaultError>, Options<ReportProblemCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ReportProblemCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportProblemCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reportProblemCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const tileLayersListQueryKey = (options?: Options<TileLayersListData>) =>
  createQueryKey('tileLayersList', options);

export const tileLayersListOptions = (options?: Options<TileLayersListData>) =>
  queryOptions<
    TileLayersListResponse,
    AxiosError<DefaultError>,
    TileLayersListResponse,
    ReturnType<typeof tileLayersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tileLayersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: tileLayersListQueryKey(options),
  });

export const titleGetTitleReportMutation = (
  options?: Partial<Options<TitleGetTitleReportData>>,
): UseMutationOptions<TitleGetTitleReportResponse, AxiosError<DefaultError>, Options<TitleGetTitleReportData>> => {
  const mutationOptions: UseMutationOptions<
    TitleGetTitleReportResponse,
    AxiosError<DefaultError>,
    Options<TitleGetTitleReportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await titleGetTitleReport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const titleGetReportDocsMutation = (
  options?: Partial<Options<TitleGetReportDocsData>>,
): UseMutationOptions<TitleGetReportDocsResponse, AxiosError<DefaultError>, Options<TitleGetReportDocsData>> => {
  const mutationOptions: UseMutationOptions<
    TitleGetReportDocsResponse,
    AxiosError<DefaultError>,
    Options<TitleGetReportDocsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await titleGetReportDocs({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const titleGetReportDocsDownloadMutation = (
  options?: Partial<Options<TitleGetReportDocsDownloadData>>,
): UseMutationOptions<
  TitleGetReportDocsDownloadResponse,
  AxiosError<DefaultError>,
  Options<TitleGetReportDocsDownloadData>
> => {
  const mutationOptions: UseMutationOptions<
    TitleGetReportDocsDownloadResponse,
    AxiosError<DefaultError>,
    Options<TitleGetReportDocsDownloadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await titleGetReportDocsDownload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const titleGetParcelDetailsQueryKey = (options: Options<TitleGetParcelDetailsData>) =>
  createQueryKey('titleGetParcelDetails', options);

export const titleGetParcelDetailsOptions = (options: Options<TitleGetParcelDetailsData>) =>
  queryOptions<
    TitleGetParcelDetailsResponse,
    AxiosError<DefaultError>,
    TitleGetParcelDetailsResponse,
    ReturnType<typeof titleGetParcelDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await titleGetParcelDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: titleGetParcelDetailsQueryKey(options),
  });

export const titleGetDocumentByIdQueryKey = (options: Options<TitleGetDocumentByIdData>) =>
  createQueryKey('titleGetDocumentById', options);

export const titleGetDocumentByIdOptions = (options: Options<TitleGetDocumentByIdData>) =>
  queryOptions<
    TitleGetDocumentByIdResponse,
    AxiosError<DefaultError>,
    TitleGetDocumentByIdResponse,
    ReturnType<typeof titleGetDocumentByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await titleGetDocumentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: titleGetDocumentByIdQueryKey(options),
  });

export const titleGetDocumentByIdDownloadQueryKey = (options: Options<TitleGetDocumentByIdDownloadData>) =>
  createQueryKey('titleGetDocumentByIdDownload', options);

export const titleGetDocumentByIdDownloadOptions = (options: Options<TitleGetDocumentByIdDownloadData>) =>
  queryOptions<
    TitleGetDocumentByIdDownloadResponse,
    AxiosError<DefaultError>,
    TitleGetDocumentByIdDownloadResponse,
    ReturnType<typeof titleGetDocumentByIdDownloadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await titleGetDocumentByIdDownload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: titleGetDocumentByIdDownloadQueryKey(options),
  });

export const titleOrderPrelimTitleReportMutation = (
  options?: Partial<Options<TitleOrderPrelimTitleReportData>>,
): UseMutationOptions<
  TitleOrderPrelimTitleReportResponse,
  AxiosError<DefaultError>,
  Options<TitleOrderPrelimTitleReportData>
> => {
  const mutationOptions: UseMutationOptions<
    TitleOrderPrelimTitleReportResponse,
    AxiosError<DefaultError>,
    Options<TitleOrderPrelimTitleReportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await titleOrderPrelimTitleReport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const titleGetDocumentsByIdsMutation = (
  options?: Partial<Options<TitleGetDocumentsByIdsData>>,
): UseMutationOptions<
  TitleGetDocumentsByIdsResponse,
  AxiosError<DefaultError>,
  Options<TitleGetDocumentsByIdsData>
> => {
  const mutationOptions: UseMutationOptions<
    TitleGetDocumentsByIdsResponse,
    AxiosError<DefaultError>,
    Options<TitleGetDocumentsByIdsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await titleGetDocumentsByIds({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const titleGetDocumentsByIdsDownloadMutation = (
  options?: Partial<Options<TitleGetDocumentsByIdsDownloadData>>,
): UseMutationOptions<
  TitleGetDocumentsByIdsDownloadResponse,
  AxiosError<DefaultError>,
  Options<TitleGetDocumentsByIdsDownloadData>
> => {
  const mutationOptions: UseMutationOptions<
    TitleGetDocumentsByIdsDownloadResponse,
    AxiosError<DefaultError>,
    Options<TitleGetDocumentsByIdsDownloadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await titleGetDocumentsByIdsDownload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usersUserCompletedVerificationQueryKey = (options?: Options<UsersUserCompletedVerificationData>) =>
  createQueryKey('usersUserCompletedVerification', options);

export const usersUserCompletedVerificationOptions = (options?: Options<UsersUserCompletedVerificationData>) =>
  queryOptions<
    UsersUserCompletedVerificationResponse,
    AxiosError<DefaultError>,
    UsersUserCompletedVerificationResponse,
    ReturnType<typeof usersUserCompletedVerificationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersUserCompletedVerification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usersUserCompletedVerificationQueryKey(options),
  });

export const usersFailedVerificationQueryKey = (options?: Options<UsersFailedVerificationData>) =>
  createQueryKey('usersFailedVerification', options);

export const usersFailedVerificationOptions = (options?: Options<UsersFailedVerificationData>) =>
  queryOptions<
    UsersFailedVerificationResponse,
    AxiosError<DefaultError>,
    UsersFailedVerificationResponse,
    ReturnType<typeof usersFailedVerificationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersFailedVerification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usersFailedVerificationQueryKey(options),
  });

export const usersSkipVerificationQueryKey = (options?: Options<UsersSkipVerificationData>) =>
  createQueryKey('usersSkipVerification', options);

export const usersSkipVerificationOptions = (options?: Options<UsersSkipVerificationData>) =>
  queryOptions<
    UsersSkipVerificationResponse,
    AxiosError<DefaultError>,
    UsersSkipVerificationResponse,
    ReturnType<typeof usersSkipVerificationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersSkipVerification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usersSkipVerificationQueryKey(options),
  });

export const usersGetMeQueryKey = (options?: Options<UsersGetMeData>) => createQueryKey('usersGetMe', options);

export const usersGetMeOptions = (options?: Options<UsersGetMeData>) =>
  queryOptions<UsersGetMeResponse, AxiosError<DefaultError>, UsersGetMeResponse, ReturnType<typeof usersGetMeQueryKey>>(
    {
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMe({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: usersGetMeQueryKey(options),
    },
  );

export const usersCheckIfDomainAllowedQueryKey = (options?: Options<UsersCheckIfDomainAllowedData>) =>
  createQueryKey('usersCheckIfDomainAllowed', options);

export const usersCheckIfDomainAllowedOptions = (options?: Options<UsersCheckIfDomainAllowedData>) =>
  queryOptions<
    UsersCheckIfDomainAllowedResponse,
    AxiosError<DefaultError>,
    UsersCheckIfDomainAllowedResponse,
    ReturnType<typeof usersCheckIfDomainAllowedQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersCheckIfDomainAllowed({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usersCheckIfDomainAllowedQueryKey(options),
  });

export const usersUpdateProfileMutation = (
  options?: Partial<Options<UsersUpdateProfileData>>,
): UseMutationOptions<UsersUpdateProfileResponse, AxiosError<DefaultError>, Options<UsersUpdateProfileData>> => {
  const mutationOptions: UseMutationOptions<
    UsersUpdateProfileResponse,
    AxiosError<DefaultError>,
    Options<UsersUpdateProfileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersUpdateProfile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usersCreateOrganizationMutation = (
  options?: Partial<Options<UsersCreateOrganizationData>>,
): UseMutationOptions<
  UsersCreateOrganizationResponse,
  AxiosError<DefaultError>,
  Options<UsersCreateOrganizationData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersCreateOrganizationResponse,
    AxiosError<DefaultError>,
    Options<UsersCreateOrganizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersCreateOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usersUpdateProjectBookmarksMutation = (
  options?: Partial<Options<UsersUpdateProjectBookmarksData>>,
): UseMutationOptions<
  UsersUpdateProjectBookmarksResponse,
  AxiosError<DefaultError>,
  Options<UsersUpdateProjectBookmarksData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersUpdateProjectBookmarksResponse,
    AxiosError<DefaultError>,
    Options<UsersUpdateProjectBookmarksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersUpdateProjectBookmarks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verificationHandleWebhookMutation = (
  options?: Partial<Options<VerificationHandleWebhookData>>,
): UseMutationOptions<
  VerificationHandleWebhookResponse,
  AxiosError<DefaultError>,
  Options<VerificationHandleWebhookData>
> => {
  const mutationOptions: UseMutationOptions<
    VerificationHandleWebhookResponse,
    AxiosError<DefaultError>,
    Options<VerificationHandleWebhookData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await verificationHandleWebhook({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetSupportingFilesQueryKey = (options: Options<CivilsearchGetSupportingFilesData>) =>
  createQueryKey('civilsearchGetSupportingFiles', options);

export const civilsearchGetSupportingFilesOptions = (options: Options<CivilsearchGetSupportingFilesData>) =>
  queryOptions<
    CivilsearchGetSupportingFilesResponse,
    AxiosError<DefaultError>,
    CivilsearchGetSupportingFilesResponse,
    ReturnType<typeof civilsearchGetSupportingFilesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetSupportingFiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetSupportingFilesQueryKey(options),
  });

export const civilsearchGetCivilSearchFileDownloadUrlQueryKey = (
  options: Options<CivilsearchGetCivilSearchFileDownloadUrlData>,
) => createQueryKey('civilsearchGetCivilSearchFileDownloadUrl', options);

export const civilsearchGetCivilSearchFileDownloadUrlOptions = (
  options: Options<CivilsearchGetCivilSearchFileDownloadUrlData>,
) =>
  queryOptions<
    CivilsearchGetCivilSearchFileDownloadUrlResponse,
    AxiosError<DefaultError>,
    CivilsearchGetCivilSearchFileDownloadUrlResponse,
    ReturnType<typeof civilsearchGetCivilSearchFileDownloadUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetCivilSearchFileDownloadUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetCivilSearchFileDownloadUrlQueryKey(options),
  });

export const civilsearchAddSupportingFileMutation = (
  options?: Partial<Options<CivilsearchAddSupportingFileData>>,
): UseMutationOptions<
  CivilsearchAddSupportingFileResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddSupportingFileData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddSupportingFileResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddSupportingFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddSupportingFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchDeleteSupportingFileMutation = (
  options?: Partial<Options<CivilsearchDeleteSupportingFileData>>,
): UseMutationOptions<
  CivilsearchDeleteSupportingFileResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchDeleteSupportingFileData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchDeleteSupportingFileResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchDeleteSupportingFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchDeleteSupportingFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddDataRequestFileMutation = (
  options?: Partial<Options<CivilsearchAddDataRequestFileData>>,
): UseMutationOptions<
  CivilsearchAddDataRequestFileResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddDataRequestFileData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddDataRequestFileResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddDataRequestFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddDataRequestFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchDeleteDataRequestFileMutation = (
  options?: Partial<Options<CivilsearchDeleteDataRequestFileData>>,
): UseMutationOptions<
  CivilsearchDeleteDataRequestFileResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchDeleteDataRequestFileData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchDeleteDataRequestFileResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchDeleteDataRequestFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchDeleteDataRequestFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchUpdateRequestFileReferencesMutation = (
  options?: Partial<Options<CivilsearchUpdateRequestFileReferencesData>>,
): UseMutationOptions<
  CivilsearchUpdateRequestFileReferencesResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateRequestFileReferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateRequestFileReferencesResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateRequestFileReferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateRequestFileReferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetAgenciesQueryKey = (options?: Options<CivilsearchGetAgenciesData>) =>
  createQueryKey('civilsearchGetAgencies', options);

export const civilsearchGetAgenciesOptions = (options?: Options<CivilsearchGetAgenciesData>) =>
  queryOptions<
    CivilsearchGetAgenciesResponse,
    AxiosError<DefaultError>,
    CivilsearchGetAgenciesResponse,
    ReturnType<typeof civilsearchGetAgenciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetAgencies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetAgenciesQueryKey(options),
  });

export const civilsearchListFilteredAgenciesQueryKey = (options: Options<CivilsearchListFilteredAgenciesData>) =>
  createQueryKey('civilsearchListFilteredAgencies', options);

export const civilsearchListFilteredAgenciesOptions = (options: Options<CivilsearchListFilteredAgenciesData>) =>
  queryOptions<
    CivilsearchListFilteredAgenciesResponse,
    AxiosError<DefaultError>,
    CivilsearchListFilteredAgenciesResponse,
    ReturnType<typeof civilsearchListFilteredAgenciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchListFilteredAgencies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchListFilteredAgenciesQueryKey(options),
  });

export const civilsearchMergeAgenciesMutation = (
  options?: Partial<Options<CivilsearchMergeAgenciesData>>,
): UseMutationOptions<
  CivilsearchMergeAgenciesResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchMergeAgenciesData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchMergeAgenciesResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchMergeAgenciesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchMergeAgencies({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchMergeAgenciesPreviewMutation = (
  options?: Partial<Options<CivilsearchMergeAgenciesPreviewData>>,
): UseMutationOptions<
  CivilsearchMergeAgenciesPreviewResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchMergeAgenciesPreviewData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchMergeAgenciesPreviewResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchMergeAgenciesPreviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchMergeAgenciesPreview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetAgencyQueryKey = (options: Options<CivilsearchGetAgencyData>) =>
  createQueryKey('civilsearchGetAgency', options);

export const civilsearchGetAgencyOptions = (options: Options<CivilsearchGetAgencyData>) =>
  queryOptions<
    CivilsearchGetAgencyResponse,
    AxiosError<DefaultError>,
    CivilsearchGetAgencyResponse,
    ReturnType<typeof civilsearchGetAgencyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetAgency({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetAgencyQueryKey(options),
  });

export const civilsearchUpdateAgencyMutation = (
  options?: Partial<Options<CivilsearchUpdateAgencyData>>,
): UseMutationOptions<
  CivilsearchUpdateAgencyResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateAgencyData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateAgencyResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateAgencyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateAgency({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetAgencyGeometriesQueryKey = (options: Options<CivilsearchGetAgencyGeometriesData>) =>
  createQueryKey('civilsearchGetAgencyGeometries', options);

export const civilsearchGetAgencyGeometriesOptions = (options: Options<CivilsearchGetAgencyGeometriesData>) =>
  queryOptions<
    CivilsearchGetAgencyGeometriesResponse,
    AxiosError<DefaultError>,
    CivilsearchGetAgencyGeometriesResponse,
    ReturnType<typeof civilsearchGetAgencyGeometriesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetAgencyGeometries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetAgencyGeometriesQueryKey(options),
  });

export const civilsearchGetAgencySubGeometriesQueryKey = (options: Options<CivilsearchGetAgencySubGeometriesData>) =>
  createQueryKey('civilsearchGetAgencySubGeometries', options);

export const civilsearchGetAgencySubGeometriesOptions = (options: Options<CivilsearchGetAgencySubGeometriesData>) =>
  queryOptions<
    CivilsearchGetAgencySubGeometriesResponse,
    AxiosError<DefaultError>,
    CivilsearchGetAgencySubGeometriesResponse,
    ReturnType<typeof civilsearchGetAgencySubGeometriesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetAgencySubGeometries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetAgencySubGeometriesQueryKey(options),
  });

export const civilsearchCreateAgencySubGeometryMutation = (
  options?: Partial<Options<CivilsearchCreateAgencySubGeometryData>>,
): UseMutationOptions<
  CivilsearchCreateAgencySubGeometryResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchCreateAgencySubGeometryData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchCreateAgencySubGeometryResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchCreateAgencySubGeometryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchCreateAgencySubGeometry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchArchiveAgencySubGeometryMutation = (
  options?: Partial<Options<CivilsearchArchiveAgencySubGeometryData>>,
): UseMutationOptions<
  CivilsearchArchiveAgencySubGeometryResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchArchiveAgencySubGeometryData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchArchiveAgencySubGeometryResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchArchiveAgencySubGeometryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchArchiveAgencySubGeometry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchUpdateAgencySubGeometryMutation = (
  options?: Partial<Options<CivilsearchUpdateAgencySubGeometryData>>,
): UseMutationOptions<
  CivilsearchUpdateAgencySubGeometryResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateAgencySubGeometryData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateAgencySubGeometryResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateAgencySubGeometryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateAgencySubGeometry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchUpdateAgencySubGeometryNoteMutation = (
  options?: Partial<Options<CivilsearchUpdateAgencySubGeometryNoteData>>,
): UseMutationOptions<
  CivilsearchUpdateAgencySubGeometryNoteResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateAgencySubGeometryNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateAgencySubGeometryNoteResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateAgencySubGeometryNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateAgencySubGeometryNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetMergeHistoryQueryKey = (options: Options<CivilsearchGetMergeHistoryData>) =>
  createQueryKey('civilsearchGetMergeHistory', options);

export const civilsearchGetMergeHistoryOptions = (options: Options<CivilsearchGetMergeHistoryData>) =>
  queryOptions<
    CivilsearchGetMergeHistoryResponse,
    AxiosError<DefaultError>,
    CivilsearchGetMergeHistoryResponse,
    ReturnType<typeof civilsearchGetMergeHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetMergeHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetMergeHistoryQueryKey(options),
  });

export const civilsearchAddAgencyLogoMutation = (
  options?: Partial<Options<CivilsearchAddAgencyLogoData>>,
): UseMutationOptions<
  CivilsearchAddAgencyLogoResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddAgencyLogoData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddAgencyLogoResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddAgencyLogoData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddAgencyLogo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddAgencyLinkMutation = (
  options?: Partial<Options<CivilsearchAddAgencyLinkData>>,
): UseMutationOptions<
  CivilsearchAddAgencyLinkResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddAgencyLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddAgencyLinkResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddAgencyLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddAgencyLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchDeleteAgencyLinkMutation = (
  options?: Partial<Options<CivilsearchDeleteAgencyLinkData>>,
): UseMutationOptions<
  CivilsearchDeleteAgencyLinkResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchDeleteAgencyLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchDeleteAgencyLinkResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchDeleteAgencyLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchDeleteAgencyLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchEditAgencyLinkMutation = (
  options?: Partial<Options<CivilsearchEditAgencyLinkData>>,
): UseMutationOptions<
  CivilsearchEditAgencyLinkResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchEditAgencyLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchEditAgencyLinkResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchEditAgencyLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchEditAgencyLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddDigitizationAccessMutation = (
  options?: Partial<Options<CivilsearchAddDigitizationAccessData>>,
): UseMutationOptions<
  CivilsearchAddDigitizationAccessResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddDigitizationAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddDigitizationAccessResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddDigitizationAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddDigitizationAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchRemoveDigitizationAccessMutation = (
  options?: Partial<Options<CivilsearchRemoveDigitizationAccessData>>,
): UseMutationOptions<
  CivilsearchRemoveDigitizationAccessResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchRemoveDigitizationAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchRemoveDigitizationAccessResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchRemoveDigitizationAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchRemoveDigitizationAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchNewAgencyContactMutation = (
  options?: Partial<Options<CivilsearchNewAgencyContactData>>,
): UseMutationOptions<
  CivilsearchNewAgencyContactResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchNewAgencyContactData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchNewAgencyContactResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchNewAgencyContactData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchNewAgencyContact({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchUpdateAgencyContactMutation = (
  options?: Partial<Options<CivilsearchUpdateAgencyContactData>>,
): UseMutationOptions<
  CivilsearchUpdateAgencyContactResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateAgencyContactData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateAgencyContactResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateAgencyContactData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateAgencyContact({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetDataRequestsQueryKey = (options?: Options<CivilsearchGetDataRequestsData>) =>
  createQueryKey('civilsearchGetDataRequests', options);

export const civilsearchGetDataRequestsOptions = (options?: Options<CivilsearchGetDataRequestsData>) =>
  queryOptions<
    CivilsearchGetDataRequestsResponse,
    AxiosError<DefaultError>,
    CivilsearchGetDataRequestsResponse,
    ReturnType<typeof civilsearchGetDataRequestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetDataRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetDataRequestsQueryKey(options),
  });

export const civilsearchListFilteredDataRequestsQueryKey = (
  options: Options<CivilsearchListFilteredDataRequestsData>,
) => createQueryKey('civilsearchListFilteredDataRequests', options);

export const civilsearchListFilteredDataRequestsOptions = (options: Options<CivilsearchListFilteredDataRequestsData>) =>
  queryOptions<
    CivilsearchListFilteredDataRequestsResponse,
    AxiosError<DefaultError>,
    CivilsearchListFilteredDataRequestsResponse,
    ReturnType<typeof civilsearchListFilteredDataRequestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchListFilteredDataRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchListFilteredDataRequestsQueryKey(options),
  });

export const civilsearchGetDataRequestQueryKey = (options: Options<CivilsearchGetDataRequestData>) =>
  createQueryKey('civilsearchGetDataRequest', options);

export const civilsearchGetDataRequestOptions = (options: Options<CivilsearchGetDataRequestData>) =>
  queryOptions<
    CivilsearchGetDataRequestResponse,
    AxiosError<DefaultError>,
    CivilsearchGetDataRequestResponse,
    ReturnType<typeof civilsearchGetDataRequestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetDataRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetDataRequestQueryKey(options),
  });

export const civilsearchUpdateDataRequestMutation = (
  options?: Partial<Options<CivilsearchUpdateDataRequestData>>,
): UseMutationOptions<
  CivilsearchUpdateDataRequestResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateDataRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateDataRequestResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateDataRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateDataRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchBulkUpdateDataRequestsMutation = (
  options?: Partial<Options<CivilsearchBulkUpdateDataRequestsData>>,
): UseMutationOptions<
  CivilsearchBulkUpdateDataRequestsResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchBulkUpdateDataRequestsData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchBulkUpdateDataRequestsResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchBulkUpdateDataRequestsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchBulkUpdateDataRequests({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchBulkCreateDataRequestNotesMutation = (
  options?: Partial<Options<CivilsearchBulkCreateDataRequestNotesData>>,
): UseMutationOptions<
  CivilsearchBulkCreateDataRequestNotesResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchBulkCreateDataRequestNotesData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchBulkCreateDataRequestNotesResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchBulkCreateDataRequestNotesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchBulkCreateDataRequestNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddDataRequestUpdateMutation = (
  options?: Partial<Options<CivilsearchAddDataRequestUpdateData>>,
): UseMutationOptions<
  CivilsearchAddDataRequestUpdateResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddDataRequestUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddDataRequestUpdateResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddDataRequestUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddDataRequestUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchDeleteDataRequestUpdateMutation = (
  options?: Partial<Options<CivilsearchDeleteDataRequestUpdateData>>,
): UseMutationOptions<
  CivilsearchDeleteDataRequestUpdateResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchDeleteDataRequestUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchDeleteDataRequestUpdateResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchDeleteDataRequestUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchDeleteDataRequestUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddDataRequestNoteMutation = (
  options?: Partial<Options<CivilsearchAddDataRequestNoteData>>,
): UseMutationOptions<
  CivilsearchAddDataRequestNoteResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddDataRequestNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddDataRequestNoteResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddDataRequestNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddDataRequestNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchDeleteDataRequestNoteMutation = (
  options?: Partial<Options<CivilsearchDeleteDataRequestNoteData>>,
): UseMutationOptions<
  CivilsearchDeleteDataRequestNoteResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchDeleteDataRequestNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchDeleteDataRequestNoteResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchDeleteDataRequestNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchDeleteDataRequestNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchUpdateDataRequestNoteMutation = (
  options?: Partial<Options<CivilsearchUpdateDataRequestNoteData>>,
): UseMutationOptions<
  CivilsearchUpdateDataRequestNoteResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateDataRequestNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateDataRequestNoteResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateDataRequestNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateDataRequestNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddNewInvoiceMutation = (
  options?: Partial<Options<CivilsearchAddNewInvoiceData>>,
): UseMutationOptions<
  CivilsearchAddNewInvoiceResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddNewInvoiceData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddNewInvoiceResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddNewInvoiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddNewInvoice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchUpdateInvoiceMutation = (
  options?: Partial<Options<CivilsearchUpdateInvoiceData>>,
): UseMutationOptions<
  CivilsearchUpdateInvoiceResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateInvoiceData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateInvoiceResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateInvoiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateInvoice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchCreateMissiveEmailDraftMutation = (
  options?: Partial<Options<CivilsearchCreateMissiveEmailDraftData>>,
): UseMutationOptions<
  CivilsearchCreateMissiveEmailDraftResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchCreateMissiveEmailDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchCreateMissiveEmailDraftResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchCreateMissiveEmailDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchCreateMissiveEmailDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetRecordRequestDataQueryKey = (options: Options<CivilsearchGetRecordRequestDataData>) =>
  createQueryKey('civilsearchGetRecordRequestData', options);

export const civilsearchGetRecordRequestDataOptions = (options: Options<CivilsearchGetRecordRequestDataData>) =>
  queryOptions<
    CivilsearchGetRecordRequestDataResponse,
    AxiosError<DefaultError>,
    CivilsearchGetRecordRequestDataResponse,
    ReturnType<typeof civilsearchGetRecordRequestDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetRecordRequestData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetRecordRequestDataQueryKey(options),
  });

export const civilsearchGetCivilSearchMessagesQueryKey = (options: Options<CivilsearchGetCivilSearchMessagesData>) =>
  createQueryKey('civilsearchGetCivilSearchMessages', options);

export const civilsearchGetCivilSearchMessagesOptions = (options: Options<CivilsearchGetCivilSearchMessagesData>) =>
  queryOptions<
    CivilsearchGetCivilSearchMessagesResponse,
    AxiosError<DefaultError>,
    CivilsearchGetCivilSearchMessagesResponse,
    ReturnType<typeof civilsearchGetCivilSearchMessagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetCivilSearchMessages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetCivilSearchMessagesQueryKey(options),
  });

export const civilsearchAddCivilSearchMessageMutation = (
  options?: Partial<Options<CivilsearchAddCivilSearchMessageData>>,
): UseMutationOptions<
  CivilsearchAddCivilSearchMessageResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddCivilSearchMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddCivilSearchMessageResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddCivilSearchMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddCivilSearchMessage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchAddCivilSearchMessageFileMutation = (
  options?: Partial<Options<CivilsearchAddCivilSearchMessageFileData>>,
): UseMutationOptions<
  CivilsearchAddCivilSearchMessageFileResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchAddCivilSearchMessageFileData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchAddCivilSearchMessageFileResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchAddCivilSearchMessageFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchAddCivilSearchMessageFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchSearchProjectsQueryKey = (options?: Options<CivilsearchSearchProjectsData>) =>
  createQueryKey('civilsearchSearchProjects', options);

export const civilsearchSearchProjectsOptions = (options?: Options<CivilsearchSearchProjectsData>) =>
  queryOptions<
    CivilsearchSearchProjectsResponse,
    AxiosError<DefaultError>,
    CivilsearchSearchProjectsResponse,
    ReturnType<typeof civilsearchSearchProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchSearchProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchSearchProjectsQueryKey(options),
  });

export const civilsearchGetProjectQueryKey = (options: Options<CivilsearchGetProjectData>) =>
  createQueryKey('civilsearchGetProject', options);

export const civilsearchGetProjectOptions = (options: Options<CivilsearchGetProjectData>) =>
  queryOptions<
    CivilsearchGetProjectResponse,
    AxiosError<DefaultError>,
    CivilsearchGetProjectResponse,
    ReturnType<typeof civilsearchGetProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetProjectQueryKey(options),
  });

export const civilsearchSearchOrganizationsQueryKey = (options?: Options<CivilsearchSearchOrganizationsData>) =>
  createQueryKey('civilsearchSearchOrganizations', options);

export const civilsearchSearchOrganizationsOptions = (options?: Options<CivilsearchSearchOrganizationsData>) =>
  queryOptions<
    CivilsearchSearchOrganizationsResponse,
    AxiosError<DefaultError>,
    CivilsearchSearchOrganizationsResponse,
    ReturnType<typeof civilsearchSearchOrganizationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchSearchOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchSearchOrganizationsQueryKey(options),
  });

export const civilsearchListFilteredProjectsQueryKey = (options: Options<CivilsearchListFilteredProjectsData>) =>
  createQueryKey('civilsearchListFilteredProjects', options);

export const civilsearchListFilteredProjectsOptions = (options: Options<CivilsearchListFilteredProjectsData>) =>
  queryOptions<
    CivilsearchListFilteredProjectsResponse,
    AxiosError<DefaultError>,
    CivilsearchListFilteredProjectsResponse,
    ReturnType<typeof civilsearchListFilteredProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchListFilteredProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchListFilteredProjectsQueryKey(options),
  });

export const civilsearchUpdateRequestAssignmentsByProjectIdMutation = (
  options?: Partial<Options<CivilsearchUpdateRequestAssignmentsByProjectIdData>>,
): UseMutationOptions<
  CivilsearchUpdateRequestAssignmentsByProjectIdResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateRequestAssignmentsByProjectIdData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateRequestAssignmentsByProjectIdResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateRequestAssignmentsByProjectIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateRequestAssignmentsByProjectId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetAiProjectDescriptionQueryKey = (options: Options<CivilsearchGetAiProjectDescriptionData>) =>
  createQueryKey('civilsearchGetAiProjectDescription', options);

export const civilsearchGetAiProjectDescriptionOptions = (options: Options<CivilsearchGetAiProjectDescriptionData>) =>
  queryOptions<
    CivilsearchGetAiProjectDescriptionResponse,
    AxiosError<DefaultError>,
    CivilsearchGetAiProjectDescriptionResponse,
    ReturnType<typeof civilsearchGetAiProjectDescriptionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetAiProjectDescription({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetAiProjectDescriptionQueryKey(options),
  });

export const civilsearchGetProjectUtilityChecksQueryKey = (options: Options<CivilsearchGetProjectUtilityChecksData>) =>
  createQueryKey('civilsearchGetProjectUtilityChecks', options);

export const civilsearchGetProjectUtilityChecksOptions = (options: Options<CivilsearchGetProjectUtilityChecksData>) =>
  queryOptions<
    CivilsearchGetProjectUtilityChecksResponse,
    AxiosError<DefaultError>,
    CivilsearchGetProjectUtilityChecksResponse,
    ReturnType<typeof civilsearchGetProjectUtilityChecksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetProjectUtilityChecks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetProjectUtilityChecksQueryKey(options),
  });

export const civilsearchGetUtilityChecksByProjectQueryKey = (
  options: Options<CivilsearchGetUtilityChecksByProjectData>,
) => createQueryKey('civilsearchGetUtilityChecksByProject', options);

export const civilsearchGetUtilityChecksByProjectOptions = (
  options: Options<CivilsearchGetUtilityChecksByProjectData>,
) =>
  queryOptions<
    CivilsearchGetUtilityChecksByProjectResponse,
    AxiosError<DefaultError>,
    CivilsearchGetUtilityChecksByProjectResponse,
    ReturnType<typeof civilsearchGetUtilityChecksByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetUtilityChecksByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetUtilityChecksByProjectQueryKey(options),
  });

export const civilsearchCreateUtilityChecksMutation = (
  options?: Partial<Options<CivilsearchCreateUtilityChecksData>>,
): UseMutationOptions<
  CivilsearchCreateUtilityChecksResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchCreateUtilityChecksData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchCreateUtilityChecksResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchCreateUtilityChecksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchCreateUtilityChecks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const civilsearchGetCivilSearchersQueryKey = (options?: Options<CivilsearchGetCivilSearchersData>) =>
  createQueryKey('civilsearchGetCivilSearchers', options);

export const civilsearchGetCivilSearchersOptions = (options?: Options<CivilsearchGetCivilSearchersData>) =>
  queryOptions<
    CivilsearchGetCivilSearchersResponse,
    AxiosError<DefaultError>,
    CivilsearchGetCivilSearchersResponse,
    ReturnType<typeof civilsearchGetCivilSearchersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await civilsearchGetCivilSearchers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: civilsearchGetCivilSearchersQueryKey(options),
  });

export const civilsearchUpdateCivilSearchersMutation = (
  options?: Partial<Options<CivilsearchUpdateCivilSearchersData>>,
): UseMutationOptions<
  CivilsearchUpdateCivilSearchersResponse,
  AxiosError<DefaultError>,
  Options<CivilsearchUpdateCivilSearchersData>
> => {
  const mutationOptions: UseMutationOptions<
    CivilsearchUpdateCivilSearchersResponse,
    AxiosError<DefaultError>,
    Options<CivilsearchUpdateCivilSearchersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await civilsearchUpdateCivilSearchers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const filesAddSingleFileMutation = (
  options?: Partial<Options<FilesAddSingleFileData>>,
): UseMutationOptions<FilesAddSingleFileResponse, AxiosError<DefaultError>, Options<FilesAddSingleFileData>> => {
  const mutationOptions: UseMutationOptions<
    FilesAddSingleFileResponse,
    AxiosError<DefaultError>,
    Options<FilesAddSingleFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await filesAddSingleFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const filesDeleteSingleFileMutation = (
  options?: Partial<Options<FilesDeleteSingleFileData>>,
): UseMutationOptions<FilesDeleteSingleFileResponse, AxiosError<DefaultError>, Options<FilesDeleteSingleFileData>> => {
  const mutationOptions: UseMutationOptions<
    FilesDeleteSingleFileResponse,
    AxiosError<DefaultError>,
    Options<FilesDeleteSingleFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await filesDeleteSingleFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const miscV2PrintMapMutation = (
  options?: Partial<Options<MiscV2PrintMapData>>,
): UseMutationOptions<MiscV2PrintMapResponse, AxiosError<DefaultError>, Options<MiscV2PrintMapData>> => {
  const mutationOptions: UseMutationOptions<
    MiscV2PrintMapResponse,
    AxiosError<DefaultError>,
    Options<MiscV2PrintMapData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await miscV2PrintMap({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const miscV2IsUrbanAreaMutation = (
  options?: Partial<Options<MiscV2IsUrbanAreaData>>,
): UseMutationOptions<MiscV2IsUrbanAreaResponse, AxiosError<DefaultError>, Options<MiscV2IsUrbanAreaData>> => {
  const mutationOptions: UseMutationOptions<
    MiscV2IsUrbanAreaResponse,
    AxiosError<DefaultError>,
    Options<MiscV2IsUrbanAreaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await miscV2IsUrbanArea({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const miscV2GetParcelSuggestionsQueryKey = (options: Options<MiscV2GetParcelSuggestionsData>) =>
  createQueryKey('miscV2GetParcelSuggestions', options);

export const miscV2GetParcelSuggestionsOptions = (options: Options<MiscV2GetParcelSuggestionsData>) =>
  queryOptions<
    MiscV2GetParcelSuggestionsResponse,
    AxiosError<DefaultError>,
    MiscV2GetParcelSuggestionsResponse,
    ReturnType<typeof miscV2GetParcelSuggestionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await miscV2GetParcelSuggestions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: miscV2GetParcelSuggestionsQueryKey(options),
  });

export const miscV2GetProjectionListQueryKey = (options: Options<MiscV2GetProjectionListData>) =>
  createQueryKey('miscV2GetProjectionList', options);

export const miscV2GetProjectionListOptions = (options: Options<MiscV2GetProjectionListData>) =>
  queryOptions<
    MiscV2GetProjectionListResponse,
    AxiosError<DefaultError>,
    MiscV2GetProjectionListResponse,
    ReturnType<typeof miscV2GetProjectionListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await miscV2GetProjectionList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: miscV2GetProjectionListQueryKey(options),
  });

export const miscV2GetAgenciesSummaryMutation = (
  options?: Partial<Options<MiscV2GetAgenciesSummaryData>>,
): UseMutationOptions<
  MiscV2GetAgenciesSummaryResponse,
  AxiosError<DefaultError>,
  Options<MiscV2GetAgenciesSummaryData>
> => {
  const mutationOptions: UseMutationOptions<
    MiscV2GetAgenciesSummaryResponse,
    AxiosError<DefaultError>,
    Options<MiscV2GetAgenciesSummaryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await miscV2GetAgenciesSummary({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const miscV2GetZoningDetailsAtPointQueryKey = (options: Options<MiscV2GetZoningDetailsAtPointData>) =>
  createQueryKey('miscV2GetZoningDetailsAtPoint', options);

export const miscV2GetZoningDetailsAtPointOptions = (options: Options<MiscV2GetZoningDetailsAtPointData>) =>
  queryOptions<
    MiscV2GetZoningDetailsAtPointResponse,
    AxiosError<DefaultError>,
    MiscV2GetZoningDetailsAtPointResponse,
    ReturnType<typeof miscV2GetZoningDetailsAtPointQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await miscV2GetZoningDetailsAtPoint({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: miscV2GetZoningDetailsAtPointQueryKey(options),
  });

export const miscV2TranscodeImageQueryKey = (options: Options<MiscV2TranscodeImageData>) =>
  createQueryKey('miscV2TranscodeImage', options);

export const miscV2TranscodeImageOptions = (options: Options<MiscV2TranscodeImageData>) =>
  queryOptions<
    MiscV2TranscodeImageResponse,
    AxiosError<DefaultError>,
    MiscV2TranscodeImageResponse,
    ReturnType<typeof miscV2TranscodeImageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await miscV2TranscodeImage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: miscV2TranscodeImageQueryKey(options),
  });

export const miscV2ValidateGeometryMutation = (
  options?: Partial<Options<MiscV2ValidateGeometryData>>,
): UseMutationOptions<
  MiscV2ValidateGeometryResponse,
  AxiosError<DefaultError>,
  Options<MiscV2ValidateGeometryData>
> => {
  const mutationOptions: UseMutationOptions<
    MiscV2ValidateGeometryResponse,
    AxiosError<DefaultError>,
    Options<MiscV2ValidateGeometryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await miscV2ValidateGeometry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2ListIntelligenceSummariesQueryKey = (
  options: Options<ProjectsV2ListIntelligenceSummariesData>,
) => createQueryKey('projectsV2ListIntelligenceSummaries', options);

export const projectsV2ListIntelligenceSummariesOptions = (options: Options<ProjectsV2ListIntelligenceSummariesData>) =>
  queryOptions<
    ProjectsV2ListIntelligenceSummariesResponse,
    AxiosError<DefaultError>,
    ProjectsV2ListIntelligenceSummariesResponse,
    ReturnType<typeof projectsV2ListIntelligenceSummariesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2ListIntelligenceSummaries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2ListIntelligenceSummariesQueryKey(options),
  });

export const projectsV2ExportIntelligenceSummariesToExcelMutation = (
  options?: Partial<Options<ProjectsV2ExportIntelligenceSummariesToExcelData>>,
): UseMutationOptions<
  ProjectsV2ExportIntelligenceSummariesToExcelResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2ExportIntelligenceSummariesToExcelData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2ExportIntelligenceSummariesToExcelResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2ExportIntelligenceSummariesToExcelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2ExportIntelligenceSummariesToExcel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2UpdateIntelligenceSummaryMutation = (
  options?: Partial<Options<ProjectsV2UpdateIntelligenceSummaryData>>,
): UseMutationOptions<
  ProjectsV2UpdateIntelligenceSummaryResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpdateIntelligenceSummaryData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateIntelligenceSummaryResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateIntelligenceSummaryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateIntelligenceSummary({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2ListProjectsV2QueryKey = (options: Options<ProjectsV2ListProjectsV2Data>) =>
  createQueryKey('projectsV2ListProjectsV2', options);

export const projectsV2ListProjectsV2Options = (options: Options<ProjectsV2ListProjectsV2Data>) =>
  queryOptions<
    ProjectsV2ListProjectsV2Response,
    AxiosError<DefaultError>,
    ProjectsV2ListProjectsV2Response,
    ReturnType<typeof projectsV2ListProjectsV2QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2ListProjectsV2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2ListProjectsV2QueryKey(options),
  });

export const projectsV2AddProjectMutation = (
  options?: Partial<Options<ProjectsV2AddProjectData>>,
): UseMutationOptions<ProjectsV2AddProjectResponse, AxiosError<DefaultError>, Options<ProjectsV2AddProjectData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddProjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2ArchiveProjectMutation = (
  options?: Partial<Options<ProjectsV2ArchiveProjectData>>,
): UseMutationOptions<
  ProjectsV2ArchiveProjectResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2ArchiveProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2ArchiveProjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2ArchiveProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2ArchiveProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetProjectQueryKey = (options: Options<ProjectsV2GetProjectData>) =>
  createQueryKey('projectsV2GetProject', options);

export const projectsV2GetProjectOptions = (options: Options<ProjectsV2GetProjectData>) =>
  queryOptions<
    ProjectsV2GetProjectResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetProjectResponse,
    ReturnType<typeof projectsV2GetProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetProjectQueryKey(options),
  });

export const projectsV2EditProjectMutation = (
  options?: Partial<Options<ProjectsV2EditProjectData>>,
): UseMutationOptions<ProjectsV2EditProjectResponse, AxiosError<DefaultError>, Options<ProjectsV2EditProjectData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2EditProjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2EditProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2EditProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2UpdateBillingTierMutation = (
  options?: Partial<Options<ProjectsV2UpdateBillingTierData>>,
): UseMutationOptions<
  ProjectsV2UpdateBillingTierResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpdateBillingTierData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateBillingTierResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateBillingTierData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateBillingTier({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2EditProjectGeometryMutation = (
  options?: Partial<Options<ProjectsV2EditProjectGeometryData>>,
): UseMutationOptions<
  ProjectsV2EditProjectGeometryResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2EditProjectGeometryData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2EditProjectGeometryResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2EditProjectGeometryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2EditProjectGeometry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2AddMembersMutation = (
  options?: Partial<Options<ProjectsV2AddMembersData>>,
): UseMutationOptions<ProjectsV2AddMembersResponse, AxiosError<DefaultError>, Options<ProjectsV2AddMembersData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddMembersResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddMembersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddMembers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2JoinProjectMutation = (
  options?: Partial<Options<ProjectsV2JoinProjectData>>,
): UseMutationOptions<ProjectsV2JoinProjectResponse, AxiosError<DefaultError>, Options<ProjectsV2JoinProjectData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2JoinProjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2JoinProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2JoinProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2LeaveProjectMutation = (
  options?: Partial<Options<ProjectsV2LeaveProjectData>>,
): UseMutationOptions<
  ProjectsV2LeaveProjectResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2LeaveProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2LeaveProjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2LeaveProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2LeaveProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2RemoveMemberMutation = (
  options?: Partial<Options<ProjectsV2RemoveMemberData>>,
): UseMutationOptions<
  ProjectsV2RemoveMemberResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2RemoveMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2RemoveMemberResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2RemoveMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2RemoveMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetParcelDataQueryKey = (options: Options<ProjectsV2GetParcelDataData>) =>
  createQueryKey('projectsV2GetParcelData', options);

export const projectsV2GetParcelDataOptions = (options: Options<ProjectsV2GetParcelDataData>) =>
  queryOptions<
    ProjectsV2GetParcelDataResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetParcelDataResponse,
    ReturnType<typeof projectsV2GetParcelDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetParcelData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetParcelDataQueryKey(options),
  });

export const projectsV2ListMapsQueryKey = (options: Options<ProjectsV2ListMapsData>) =>
  createQueryKey('projectsV2ListMaps', options);

export const projectsV2ListMapsOptions = (options: Options<ProjectsV2ListMapsData>) =>
  queryOptions<
    ProjectsV2ListMapsResponse,
    AxiosError<DefaultError>,
    ProjectsV2ListMapsResponse,
    ReturnType<typeof projectsV2ListMapsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2ListMaps({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2ListMapsQueryKey(options),
  });

export const projectsV2AddMapMutation = (
  options?: Partial<Options<ProjectsV2AddMapData>>,
): UseMutationOptions<ProjectsV2AddMapResponse, AxiosError<DefaultError>, Options<ProjectsV2AddMapData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddMapResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddMapData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddMap({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2DuplicateMapQueryKey = (options: Options<ProjectsV2DuplicateMapData>) =>
  createQueryKey('projectsV2DuplicateMap', options);

export const projectsV2DuplicateMapOptions = (options: Options<ProjectsV2DuplicateMapData>) =>
  queryOptions<
    ProjectsV2DuplicateMapResponse,
    AxiosError<DefaultError>,
    ProjectsV2DuplicateMapResponse,
    ReturnType<typeof projectsV2DuplicateMapQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2DuplicateMap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2DuplicateMapQueryKey(options),
  });

export const projectsV2DeleteMapMutation = (
  options?: Partial<Options<ProjectsV2DeleteMapData>>,
): UseMutationOptions<ProjectsV2DeleteMapResponse, AxiosError<DefaultError>, Options<ProjectsV2DeleteMapData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2DeleteMapResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2DeleteMapData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2DeleteMap({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetMapQueryKey = (options: Options<ProjectsV2GetMapData>) =>
  createQueryKey('projectsV2GetMap', options);

export const projectsV2GetMapOptions = (options: Options<ProjectsV2GetMapData>) =>
  queryOptions<
    ProjectsV2GetMapResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetMapResponse,
    ReturnType<typeof projectsV2GetMapQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetMap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetMapQueryKey(options),
  });

export const projectsV2UpdateMapMutation = (
  options?: Partial<Options<ProjectsV2UpdateMapData>>,
): UseMutationOptions<ProjectsV2UpdateMapResponse, AxiosError<DefaultError>, Options<ProjectsV2UpdateMapData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateMapResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateMapData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateMap({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2AddObjectMutation = (
  options?: Partial<Options<ProjectsV2AddObjectData>>,
): UseMutationOptions<ProjectsV2AddObjectResponse, AxiosError<DefaultError>, Options<ProjectsV2AddObjectData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddObjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddObjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddObject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2AddObjectsMutation = (
  options?: Partial<Options<ProjectsV2AddObjectsData>>,
): UseMutationOptions<ProjectsV2AddObjectsResponse, AxiosError<DefaultError>, Options<ProjectsV2AddObjectsData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddObjectsResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddObjectsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddObjects({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2DeleteObjectMutation = (
  options?: Partial<Options<ProjectsV2DeleteObjectData>>,
): UseMutationOptions<
  ProjectsV2DeleteObjectResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2DeleteObjectData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2DeleteObjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2DeleteObjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2DeleteObject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2UndoDeleteObjectMutation = (
  options?: Partial<Options<ProjectsV2UndoDeleteObjectData>>,
): UseMutationOptions<
  ProjectsV2UndoDeleteObjectResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UndoDeleteObjectData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UndoDeleteObjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UndoDeleteObjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UndoDeleteObject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2UpdateObjectMutation = (
  options?: Partial<Options<ProjectsV2UpdateObjectData>>,
): UseMutationOptions<
  ProjectsV2UpdateObjectResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpdateObjectData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateObjectResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateObjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateObject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2DeleteObjectFilesMutation = (
  options?: Partial<Options<ProjectsV2DeleteObjectFilesData>>,
): UseMutationOptions<
  ProjectsV2DeleteObjectFilesResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2DeleteObjectFilesData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2DeleteObjectFilesResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2DeleteObjectFilesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2DeleteObjectFiles({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2AddObjectFileMutation = (
  options?: Partial<Options<ProjectsV2AddObjectFileData>>,
): UseMutationOptions<
  ProjectsV2AddObjectFileResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2AddObjectFileData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddObjectFileResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddObjectFileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddObjectFile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2AddCommentMutation = (
  options?: Partial<Options<ProjectsV2AddCommentData>>,
): UseMutationOptions<ProjectsV2AddCommentResponse, AxiosError<DefaultError>, Options<ProjectsV2AddCommentData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddCommentResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2ArchiveCommentMutation = (
  options?: Partial<Options<ProjectsV2ArchiveCommentData>>,
): UseMutationOptions<
  ProjectsV2ArchiveCommentResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2ArchiveCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2ArchiveCommentResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2ArchiveCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2ArchiveComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2UpdateCommentMutation = (
  options?: Partial<Options<ProjectsV2UpdateCommentData>>,
): UseMutationOptions<
  ProjectsV2UpdateCommentResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpdateCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateCommentResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2DeletePermitMutation = (
  options?: Partial<Options<ProjectsV2DeletePermitData>>,
): UseMutationOptions<
  ProjectsV2DeletePermitResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2DeletePermitData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2DeletePermitResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2DeletePermitData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2DeletePermit({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetPermitQueryKey = (options: Options<ProjectsV2GetPermitData>) =>
  createQueryKey('projectsV2GetPermit', options);

export const projectsV2GetPermitOptions = (options: Options<ProjectsV2GetPermitData>) =>
  queryOptions<
    ProjectsV2GetPermitResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetPermitResponse,
    ReturnType<typeof projectsV2GetPermitQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetPermit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetPermitQueryKey(options),
  });

export const projectsV2UpsertPermitMutation = (
  options?: Partial<Options<ProjectsV2UpsertPermitData>>,
): UseMutationOptions<
  ProjectsV2UpsertPermitResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpsertPermitData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpsertPermitResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpsertPermitData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpsertPermit({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2ListTransactionsQueryKey = (options: Options<ProjectsV2ListTransactionsData>) =>
  createQueryKey('projectsV2ListTransactions', options);

export const projectsV2ListTransactionsOptions = (options: Options<ProjectsV2ListTransactionsData>) =>
  queryOptions<
    ProjectsV2ListTransactionsResponse,
    AxiosError<DefaultError>,
    ProjectsV2ListTransactionsResponse,
    ReturnType<typeof projectsV2ListTransactionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2ListTransactions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2ListTransactionsQueryKey(options),
  });

export const projectsV2PrintReceiptMutation = (
  options?: Partial<Options<ProjectsV2PrintReceiptData>>,
): UseMutationOptions<
  ProjectsV2PrintReceiptResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2PrintReceiptData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2PrintReceiptResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2PrintReceiptData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2PrintReceipt({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2PrintQuoteMutation = (
  options?: Partial<Options<ProjectsV2PrintQuoteData>>,
): UseMutationOptions<ProjectsV2PrintQuoteResponse, AxiosError<DefaultError>, Options<ProjectsV2PrintQuoteData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2PrintQuoteResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2PrintQuoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2PrintQuote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetIntelligenceFeaturesQueryKey = (options: Options<ProjectsV2GetIntelligenceFeaturesData>) =>
  createQueryKey('projectsV2GetIntelligenceFeatures', options);

export const projectsV2GetIntelligenceFeaturesOptions = (options: Options<ProjectsV2GetIntelligenceFeaturesData>) =>
  queryOptions<
    ProjectsV2GetIntelligenceFeaturesResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetIntelligenceFeaturesResponse,
    ReturnType<typeof projectsV2GetIntelligenceFeaturesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetIntelligenceFeatures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetIntelligenceFeaturesQueryKey(options),
  });

export const projectsV2UpdateIntelligenceStatusMutation = (
  options?: Partial<Options<ProjectsV2UpdateIntelligenceStatusData>>,
): UseMutationOptions<
  ProjectsV2UpdateIntelligenceStatusResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpdateIntelligenceStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateIntelligenceStatusResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateIntelligenceStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateIntelligenceStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GenerateProposalPacketMutation = (
  options?: Partial<Options<ProjectsV2GenerateProposalPacketData>>,
): UseMutationOptions<
  ProjectsV2GenerateProposalPacketResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2GenerateProposalPacketData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2GenerateProposalPacketResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2GenerateProposalPacketData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2GenerateProposalPacket({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GenerateRecordsResearchReportMutation = (
  options?: Partial<Options<ProjectsV2GenerateRecordsResearchReportData>>,
): UseMutationOptions<
  ProjectsV2GenerateRecordsResearchReportResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2GenerateRecordsResearchReportData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2GenerateRecordsResearchReportResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2GenerateRecordsResearchReportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2GenerateRecordsResearchReport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetProjectDownloadsQueryKey = (options: Options<ProjectsV2GetProjectDownloadsData>) =>
  createQueryKey('projectsV2GetProjectDownloads', options);

export const projectsV2GetProjectDownloadsOptions = (options: Options<ProjectsV2GetProjectDownloadsData>) =>
  queryOptions<
    ProjectsV2GetProjectDownloadsResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetProjectDownloadsResponse,
    ReturnType<typeof projectsV2GetProjectDownloadsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetProjectDownloads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetProjectDownloadsQueryKey(options),
  });

export const projectsV2GetDownloadSignedUrlQueryKey = (options: Options<ProjectsV2GetDownloadSignedUrlData>) =>
  createQueryKey('projectsV2GetDownloadSignedUrl', options);

export const projectsV2GetDownloadSignedUrlOptions = (options: Options<ProjectsV2GetDownloadSignedUrlData>) =>
  queryOptions<
    ProjectsV2GetDownloadSignedUrlResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetDownloadSignedUrlResponse,
    ReturnType<typeof projectsV2GetDownloadSignedUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetDownloadSignedUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetDownloadSignedUrlQueryKey(options),
  });

export const projectsV2GetUtilitiesFileSignedUrlQueryKey = (
  options: Options<ProjectsV2GetUtilitiesFileSignedUrlData>,
) => createQueryKey('projectsV2GetUtilitiesFileSignedUrl', options);

export const projectsV2GetUtilitiesFileSignedUrlOptions = (options: Options<ProjectsV2GetUtilitiesFileSignedUrlData>) =>
  queryOptions<
    ProjectsV2GetUtilitiesFileSignedUrlResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetUtilitiesFileSignedUrlResponse,
    ReturnType<typeof projectsV2GetUtilitiesFileSignedUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetUtilitiesFileSignedUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetUtilitiesFileSignedUrlQueryKey(options),
  });

export const projectsV2GetStoredFileDownloadUrlQueryKey = (options: Options<ProjectsV2GetStoredFileDownloadUrlData>) =>
  createQueryKey('projectsV2GetStoredFileDownloadUrl', options);

export const projectsV2GetStoredFileDownloadUrlOptions = (options: Options<ProjectsV2GetStoredFileDownloadUrlData>) =>
  queryOptions<
    ProjectsV2GetStoredFileDownloadUrlResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetStoredFileDownloadUrlResponse,
    ReturnType<typeof projectsV2GetStoredFileDownloadUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetStoredFileDownloadUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetStoredFileDownloadUrlQueryKey(options),
  });

export const projectsV2AddIntelligenceCommentMutation = (
  options?: Partial<Options<ProjectsV2AddIntelligenceCommentData>>,
): UseMutationOptions<
  ProjectsV2AddIntelligenceCommentResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2AddIntelligenceCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2AddIntelligenceCommentResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2AddIntelligenceCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2AddIntelligenceComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2DeleteIntelligenceCommentMutation = (
  options?: Partial<Options<ProjectsV2DeleteIntelligenceCommentData>>,
): UseMutationOptions<
  ProjectsV2DeleteIntelligenceCommentResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2DeleteIntelligenceCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2DeleteIntelligenceCommentResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2DeleteIntelligenceCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2DeleteIntelligenceComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2SubmitDownloadRequestMutation = (
  options?: Partial<Options<ProjectsV2SubmitDownloadRequestData>>,
): UseMutationOptions<
  ProjectsV2SubmitDownloadRequestResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2SubmitDownloadRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2SubmitDownloadRequestResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2SubmitDownloadRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2SubmitDownloadRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetUtilityAgenciesMutation = (
  options?: Partial<Options<ProjectsV2GetUtilityAgenciesData>>,
): UseMutationOptions<
  ProjectsV2GetUtilityAgenciesResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2GetUtilityAgenciesData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2GetUtilityAgenciesResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2GetUtilityAgenciesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2GetUtilityAgencies({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetDataRequestsV2QueryKey = (options: Options<ProjectsV2GetDataRequestsV2Data>) =>
  createQueryKey('projectsV2GetDataRequestsV2', options);

export const projectsV2GetDataRequestsV2Options = (options: Options<ProjectsV2GetDataRequestsV2Data>) =>
  queryOptions<
    ProjectsV2GetDataRequestsV2Response,
    AxiosError<DefaultError>,
    ProjectsV2GetDataRequestsV2Response,
    ReturnType<typeof projectsV2GetDataRequestsV2QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetDataRequestsV2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetDataRequestsV2QueryKey(options),
  });

export const projectsV2SubmitDataRequestsV2Mutation = (
  options?: Partial<Options<ProjectsV2SubmitDataRequestsV2Data>>,
): UseMutationOptions<
  ProjectsV2SubmitDataRequestsV2Response,
  AxiosError<DefaultError>,
  Options<ProjectsV2SubmitDataRequestsV2Data>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2SubmitDataRequestsV2Response,
    AxiosError<DefaultError>,
    Options<ProjectsV2SubmitDataRequestsV2Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2SubmitDataRequestsV2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetCivilSearchMessagesQueryKey = (options: Options<ProjectsV2GetCivilSearchMessagesData>) =>
  createQueryKey('projectsV2GetCivilSearchMessages', options);

export const projectsV2GetCivilSearchMessagesOptions = (options: Options<ProjectsV2GetCivilSearchMessagesData>) =>
  queryOptions<
    ProjectsV2GetCivilSearchMessagesResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetCivilSearchMessagesResponse,
    ReturnType<typeof projectsV2GetCivilSearchMessagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetCivilSearchMessages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetCivilSearchMessagesQueryKey(options),
  });

export const projectsV2NewCivilSearchMessageMutation = (
  options?: Partial<Options<ProjectsV2NewCivilSearchMessageData>>,
): UseMutationOptions<
  ProjectsV2NewCivilSearchMessageResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2NewCivilSearchMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2NewCivilSearchMessageResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2NewCivilSearchMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2NewCivilSearchMessage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetCivilSearchActivitiesQueryKey = (options: Options<ProjectsV2GetCivilSearchActivitiesData>) =>
  createQueryKey('projectsV2GetCivilSearchActivities', options);

export const projectsV2GetCivilSearchActivitiesOptions = (options: Options<ProjectsV2GetCivilSearchActivitiesData>) =>
  queryOptions<
    ProjectsV2GetCivilSearchActivitiesResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetCivilSearchActivitiesResponse,
    ReturnType<typeof projectsV2GetCivilSearchActivitiesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetCivilSearchActivities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetCivilSearchActivitiesQueryKey(options),
  });

export const projectsV2GetLatestCivilSearchActivityQueryKey = (
  options: Options<ProjectsV2GetLatestCivilSearchActivityData>,
) => createQueryKey('projectsV2GetLatestCivilSearchActivity', options);

export const projectsV2GetLatestCivilSearchActivityOptions = (
  options: Options<ProjectsV2GetLatestCivilSearchActivityData>,
) =>
  queryOptions<
    ProjectsV2GetLatestCivilSearchActivityResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetLatestCivilSearchActivityResponse,
    ReturnType<typeof projectsV2GetLatestCivilSearchActivityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetLatestCivilSearchActivity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetLatestCivilSearchActivityQueryKey(options),
  });

export const projectsV2GetLayersQueryKey = (options: Options<ProjectsV2GetLayersData>) =>
  createQueryKey('projectsV2GetLayers', options);

export const projectsV2GetLayersOptions = (options: Options<ProjectsV2GetLayersData>) =>
  queryOptions<
    ProjectsV2GetLayersResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetLayersResponse,
    ReturnType<typeof projectsV2GetLayersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetLayers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetLayersQueryKey(options),
  });

export const projectsV2GetDownloadRestrictionsQueryKey = (options: Options<ProjectsV2GetDownloadRestrictionsData>) =>
  createQueryKey('projectsV2GetDownloadRestrictions', options);

export const projectsV2GetDownloadRestrictionsOptions = (options: Options<ProjectsV2GetDownloadRestrictionsData>) =>
  queryOptions<
    ProjectsV2GetDownloadRestrictionsResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetDownloadRestrictionsResponse,
    ReturnType<typeof projectsV2GetDownloadRestrictionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetDownloadRestrictions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetDownloadRestrictionsQueryKey(options),
  });

export const projectsV2GetDigitizationAccessQueryKey = (options: Options<ProjectsV2GetDigitizationAccessData>) =>
  createQueryKey('projectsV2GetDigitizationAccess', options);

export const projectsV2GetDigitizationAccessOptions = (options: Options<ProjectsV2GetDigitizationAccessData>) =>
  queryOptions<
    ProjectsV2GetDigitizationAccessResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetDigitizationAccessResponse,
    ReturnType<typeof projectsV2GetDigitizationAccessQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetDigitizationAccess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetDigitizationAccessQueryKey(options),
  });

export const projectsV2GetProjectLayerAssetPresenceMutation = (
  options?: Partial<Options<ProjectsV2GetProjectLayerAssetPresenceData>>,
): UseMutationOptions<
  ProjectsV2GetProjectLayerAssetPresenceResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2GetProjectLayerAssetPresenceData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2GetProjectLayerAssetPresenceResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2GetProjectLayerAssetPresenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2GetProjectLayerAssetPresence({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GenerateFloodReportMutation = (
  options?: Partial<Options<ProjectsV2GenerateFloodReportData>>,
): UseMutationOptions<
  ProjectsV2GenerateFloodReportResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2GenerateFloodReportData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2GenerateFloodReportResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2GenerateFloodReportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2GenerateFloodReport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetHistoricalUsgsMapsQueryKey = (options: Options<ProjectsV2GetHistoricalUsgsMapsData>) =>
  createQueryKey('projectsV2GetHistoricalUsgsMaps', options);

export const projectsV2GetHistoricalUsgsMapsOptions = (options: Options<ProjectsV2GetHistoricalUsgsMapsData>) =>
  queryOptions<
    ProjectsV2GetHistoricalUsgsMapsResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetHistoricalUsgsMapsResponse,
    ReturnType<typeof projectsV2GetHistoricalUsgsMapsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetHistoricalUsgsMaps({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetHistoricalUsgsMapsQueryKey(options),
  });

export const projectsV2GetCgsRegulatoryQuadrangleListQueryKey = (
  options: Options<ProjectsV2GetCgsRegulatoryQuadrangleListData>,
) => createQueryKey('projectsV2GetCgsRegulatoryQuadrangleList', options);

export const projectsV2GetCgsRegulatoryQuadrangleListOptions = (
  options: Options<ProjectsV2GetCgsRegulatoryQuadrangleListData>,
) =>
  queryOptions<
    ProjectsV2GetCgsRegulatoryQuadrangleListResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetCgsRegulatoryQuadrangleListResponse,
    ReturnType<typeof projectsV2GetCgsRegulatoryQuadrangleListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetCgsRegulatoryQuadrangleList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetCgsRegulatoryQuadrangleListQueryKey(options),
  });

export const projectsV2GenerateEvidenceEmailChainMutation = (
  options?: Partial<Options<ProjectsV2GenerateEvidenceEmailChainData>>,
): UseMutationOptions<
  ProjectsV2GenerateEvidenceEmailChainResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2GenerateEvidenceEmailChainData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2GenerateEvidenceEmailChainResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2GenerateEvidenceEmailChainData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2GenerateEvidenceEmailChain({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2UpdateUtilityNoteMutation = (
  options?: Partial<Options<ProjectsV2UpdateUtilityNoteData>>,
): UseMutationOptions<
  ProjectsV2UpdateUtilityNoteResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2UpdateUtilityNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2UpdateUtilityNoteResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2UpdateUtilityNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2UpdateUtilityNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2DownloadCsAttachmentsMutation = (
  options?: Partial<Options<ProjectsV2DownloadCsAttachmentsData>>,
): UseMutationOptions<
  ProjectsV2DownloadCsAttachmentsResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2DownloadCsAttachmentsData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2DownloadCsAttachmentsResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2DownloadCsAttachmentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2DownloadCsAttachments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetAntennaDataQueryKey = (options: Options<ProjectsV2GetAntennaDataData>) =>
  createQueryKey('projectsV2GetAntennaData', options);

export const projectsV2GetAntennaDataOptions = (options: Options<ProjectsV2GetAntennaDataData>) =>
  queryOptions<
    ProjectsV2GetAntennaDataResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetAntennaDataResponse,
    ReturnType<typeof projectsV2GetAntennaDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetAntennaData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetAntennaDataQueryKey(options),
  });

export const projectsV2GetEnvironmentalStudyDataQueryKey = (
  options: Options<ProjectsV2GetEnvironmentalStudyDataData>,
) => createQueryKey('projectsV2GetEnvironmentalStudyData', options);

export const projectsV2GetEnvironmentalStudyDataOptions = (options: Options<ProjectsV2GetEnvironmentalStudyDataData>) =>
  queryOptions<
    ProjectsV2GetEnvironmentalStudyDataResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetEnvironmentalStudyDataResponse,
    ReturnType<typeof projectsV2GetEnvironmentalStudyDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetEnvironmentalStudyData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetEnvironmentalStudyDataQueryKey(options),
  });

export const projectsV2GetEnvironmentalStudyPdfQueryKey = (options: Options<ProjectsV2GetEnvironmentalStudyPdfData>) =>
  createQueryKey('projectsV2GetEnvironmentalStudyPdf', options);

export const projectsV2GetEnvironmentalStudyPdfOptions = (options: Options<ProjectsV2GetEnvironmentalStudyPdfData>) =>
  queryOptions<
    ProjectsV2GetEnvironmentalStudyPdfResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetEnvironmentalStudyPdfResponse,
    ReturnType<typeof projectsV2GetEnvironmentalStudyPdfQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetEnvironmentalStudyPdf({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetEnvironmentalStudyPdfQueryKey(options),
  });

export const projectsV2RequestErisDataMutation = (
  options?: Partial<Options<ProjectsV2RequestErisDataData>>,
): UseMutationOptions<
  ProjectsV2RequestErisDataResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2RequestErisDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2RequestErisDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2RequestErisDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2RequestErisData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV2GetLandRightsSummaryQueryKey = (options: Options<ProjectsV2GetLandRightsSummaryData>) =>
  createQueryKey('projectsV2GetLandRightsSummary', options);

export const projectsV2GetLandRightsSummaryOptions = (options: Options<ProjectsV2GetLandRightsSummaryData>) =>
  queryOptions<
    ProjectsV2GetLandRightsSummaryResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetLandRightsSummaryResponse,
    ReturnType<typeof projectsV2GetLandRightsSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetLandRightsSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetLandRightsSummaryQueryKey(options),
  });

export const projectsV2GetGeotechnicalSummaryQueryKey = (options: Options<ProjectsV2GetGeotechnicalSummaryData>) =>
  createQueryKey('projectsV2GetGeotechnicalSummary', options);

export const projectsV2GetGeotechnicalSummaryOptions = (options: Options<ProjectsV2GetGeotechnicalSummaryData>) =>
  queryOptions<
    ProjectsV2GetGeotechnicalSummaryResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetGeotechnicalSummaryResponse,
    ReturnType<typeof projectsV2GetGeotechnicalSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetGeotechnicalSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetGeotechnicalSummaryQueryKey(options),
  });

export const projectsV2GetEnvironmentalSummaryQueryKey = (options: Options<ProjectsV2GetEnvironmentalSummaryData>) =>
  createQueryKey('projectsV2GetEnvironmentalSummary', options);

export const projectsV2GetEnvironmentalSummaryOptions = (options: Options<ProjectsV2GetEnvironmentalSummaryData>) =>
  queryOptions<
    ProjectsV2GetEnvironmentalSummaryResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetEnvironmentalSummaryResponse,
    ReturnType<typeof projectsV2GetEnvironmentalSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetEnvironmentalSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetEnvironmentalSummaryQueryKey(options),
  });

export const projectsV2GetUtilitiesSummaryQueryKey = (options: Options<ProjectsV2GetUtilitiesSummaryData>) =>
  createQueryKey('projectsV2GetUtilitiesSummary', options);

export const projectsV2GetUtilitiesSummaryOptions = (options: Options<ProjectsV2GetUtilitiesSummaryData>) =>
  queryOptions<
    ProjectsV2GetUtilitiesSummaryResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetUtilitiesSummaryResponse,
    ReturnType<typeof projectsV2GetUtilitiesSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetUtilitiesSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetUtilitiesSummaryQueryKey(options),
  });

export const projectsV2GetProjectAgenciesQueryKey = (options: Options<ProjectsV2GetProjectAgenciesData>) =>
  createQueryKey('projectsV2GetProjectAgencies', options);

export const projectsV2GetProjectAgenciesOptions = (options: Options<ProjectsV2GetProjectAgenciesData>) =>
  queryOptions<
    ProjectsV2GetProjectAgenciesResponse,
    AxiosError<DefaultError>,
    ProjectsV2GetProjectAgenciesResponse,
    ReturnType<typeof projectsV2GetProjectAgenciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV2GetProjectAgencies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV2GetProjectAgenciesQueryKey(options),
  });

export const projectsV2PopulateProjectAgenciesDataMutation = (
  options?: Partial<Options<ProjectsV2PopulateProjectAgenciesDataData>>,
): UseMutationOptions<
  ProjectsV2PopulateProjectAgenciesDataResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV2PopulateProjectAgenciesDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV2PopulateProjectAgenciesDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV2PopulateProjectAgenciesDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV2PopulateProjectAgenciesData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authV3GetAuthCodeMutation = (
  options?: Partial<Options<AuthV3GetAuthCodeData>>,
): UseMutationOptions<AuthV3GetAuthCodeResponse, AxiosError<DefaultError>, Options<AuthV3GetAuthCodeData>> => {
  const mutationOptions: UseMutationOptions<
    AuthV3GetAuthCodeResponse,
    AxiosError<DefaultError>,
    Options<AuthV3GetAuthCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authV3GetAuthCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authV3LoginMutation = (
  options?: Partial<Options<AuthV3LoginData>>,
): UseMutationOptions<AuthV3LoginResponse, AxiosError<DefaultError>, Options<AuthV3LoginData>> => {
  const mutationOptions: UseMutationOptions<AuthV3LoginResponse, AxiosError<DefaultError>, Options<AuthV3LoginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await authV3Login({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authV3SamlConsumeMutation = (
  options?: Partial<Options<AuthV3SamlConsumeData>>,
): UseMutationOptions<AuthV3SamlConsumeResponse, AxiosError<DefaultError>, Options<AuthV3SamlConsumeData>> => {
  const mutationOptions: UseMutationOptions<
    AuthV3SamlConsumeResponse,
    AxiosError<DefaultError>,
    Options<AuthV3SamlConsumeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authV3SamlConsume({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authV3RegisterMutation = (
  options?: Partial<Options<AuthV3RegisterData>>,
): UseMutationOptions<AuthV3RegisterResponse, AxiosError<DefaultError>, Options<AuthV3RegisterData>> => {
  const mutationOptions: UseMutationOptions<
    AuthV3RegisterResponse,
    AxiosError<DefaultError>,
    Options<AuthV3RegisterData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authV3Register({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authV3LogOutMutation = (
  options?: Partial<Options<AuthV3LogOutData>>,
): UseMutationOptions<AuthV3LogOutResponse, AxiosError<DefaultError>, Options<AuthV3LogOutData>> => {
  const mutationOptions: UseMutationOptions<
    AuthV3LogOutResponse,
    AxiosError<DefaultError>,
    Options<AuthV3LogOutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authV3LogOut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authV3JoinOrgByDomainMutation = (
  options?: Partial<Options<AuthV3JoinOrgByDomainData>>,
): UseMutationOptions<AuthV3JoinOrgByDomainResponse, AxiosError<DefaultError>, Options<AuthV3JoinOrgByDomainData>> => {
  const mutationOptions: UseMutationOptions<
    AuthV3JoinOrgByDomainResponse,
    AxiosError<DefaultError>,
    Options<AuthV3JoinOrgByDomainData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authV3JoinOrgByDomain({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const dataStoreMessageHandlerMutation = (
  options?: Partial<Options<DataStoreMessageHandlerData>>,
): UseMutationOptions<
  DataStoreMessageHandlerResponse,
  AxiosError<DefaultError>,
  Options<DataStoreMessageHandlerData>
> => {
  const mutationOptions: UseMutationOptions<
    DataStoreMessageHandlerResponse,
    AxiosError<DefaultError>,
    Options<DataStoreMessageHandlerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dataStoreMessageHandler({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3ListProjectsQueryKey = (options: Options<ProjectsV3ListProjectsData>) =>
  createQueryKey('projectsV3ListProjects', options);

export const projectsV3ListProjectsOptions = (options: Options<ProjectsV3ListProjectsData>) =>
  queryOptions<
    ProjectsV3ListProjectsResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListProjectsResponse,
    ReturnType<typeof projectsV3ListProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListProjectsQueryKey(options),
  });

export const projectsV3ListIntelligenceSummariesQueryKey = (
  options: Options<ProjectsV3ListIntelligenceSummariesData>,
) => createQueryKey('projectsV3ListIntelligenceSummaries', options);

export const projectsV3ListIntelligenceSummariesOptions = (options: Options<ProjectsV3ListIntelligenceSummariesData>) =>
  queryOptions<
    ProjectsV3ListIntelligenceSummariesResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListIntelligenceSummariesResponse,
    ReturnType<typeof projectsV3ListIntelligenceSummariesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListIntelligenceSummaries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListIntelligenceSummariesQueryKey(options),
  });

export const projectsV3GetIntelligenceSummaryMetaQueryKey = (
  options: Options<ProjectsV3GetIntelligenceSummaryMetaData>,
) => createQueryKey('projectsV3GetIntelligenceSummaryMeta', options);

export const projectsV3GetIntelligenceSummaryMetaOptions = (
  options: Options<ProjectsV3GetIntelligenceSummaryMetaData>,
) =>
  queryOptions<
    ProjectsV3GetIntelligenceSummaryMetaResponse,
    AxiosError<DefaultError>,
    ProjectsV3GetIntelligenceSummaryMetaResponse,
    ReturnType<typeof projectsV3GetIntelligenceSummaryMetaQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3GetIntelligenceSummaryMeta({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3GetIntelligenceSummaryMetaQueryKey(options),
  });

export const projectsV3ExportIntelligenceSummariesToExcelMutation = (
  options?: Partial<Options<ProjectsV3ExportIntelligenceSummariesToExcelData>>,
): UseMutationOptions<
  ProjectsV3ExportIntelligenceSummariesToExcelResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3ExportIntelligenceSummariesToExcelData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3ExportIntelligenceSummariesToExcelResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3ExportIntelligenceSummariesToExcelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3ExportIntelligenceSummariesToExcel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3BulkUpdateConstructionDatesMutation = (
  options?: Partial<Options<ProjectsV3BulkUpdateConstructionDatesData>>,
): UseMutationOptions<
  ProjectsV3BulkUpdateConstructionDatesResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3BulkUpdateConstructionDatesData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3BulkUpdateConstructionDatesResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3BulkUpdateConstructionDatesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3BulkUpdateConstructionDates({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3BulkUpdatePlanStatusMutation = (
  options?: Partial<Options<ProjectsV3BulkUpdatePlanStatusData>>,
): UseMutationOptions<
  ProjectsV3BulkUpdatePlanStatusResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3BulkUpdatePlanStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3BulkUpdatePlanStatusResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3BulkUpdatePlanStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3BulkUpdatePlanStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3ListAllProjectsQueryKey = (options: Options<ProjectsV3ListAllProjectsData>) =>
  createQueryKey('projectsV3ListAllProjects', options);

export const projectsV3ListAllProjectsOptions = (options: Options<ProjectsV3ListAllProjectsData>) =>
  queryOptions<
    ProjectsV3ListAllProjectsResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListAllProjectsResponse,
    ReturnType<typeof projectsV3ListAllProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListAllProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListAllProjectsQueryKey(options),
  });

export const projectsV3GetSandboxProjectQueryKey = (options: Options<ProjectsV3GetSandboxProjectData>) =>
  createQueryKey('projectsV3GetSandboxProject', options);

export const projectsV3GetSandboxProjectOptions = (options: Options<ProjectsV3GetSandboxProjectData>) =>
  queryOptions<
    ProjectsV3GetSandboxProjectResponse,
    AxiosError<DefaultError>,
    ProjectsV3GetSandboxProjectResponse,
    ReturnType<typeof projectsV3GetSandboxProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3GetSandboxProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3GetSandboxProjectQueryKey(options),
  });

export const projectsV3ExportProjectsToExcelMutation = (
  options?: Partial<Options<ProjectsV3ExportProjectsToExcelData>>,
): UseMutationOptions<
  ProjectsV3ExportProjectsToExcelResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3ExportProjectsToExcelData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3ExportProjectsToExcelResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3ExportProjectsToExcelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3ExportProjectsToExcel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3ToggleProjectBookmarkMutation = (
  options?: Partial<Options<ProjectsV3ToggleProjectBookmarkData>>,
): UseMutationOptions<
  ProjectsV3ToggleProjectBookmarkResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3ToggleProjectBookmarkData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3ToggleProjectBookmarkResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3ToggleProjectBookmarkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3ToggleProjectBookmark({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3BulkUpdateProjectsMutation = (
  options?: Partial<Options<ProjectsV3BulkUpdateProjectsData>>,
): UseMutationOptions<
  ProjectsV3BulkUpdateProjectsResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3BulkUpdateProjectsData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3BulkUpdateProjectsResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3BulkUpdateProjectsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3BulkUpdateProjects({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3BulkAddProjectBookmarksMutation = (
  options?: Partial<Options<ProjectsV3BulkAddProjectBookmarksData>>,
): UseMutationOptions<
  ProjectsV3BulkAddProjectBookmarksResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3BulkAddProjectBookmarksData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3BulkAddProjectBookmarksResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3BulkAddProjectBookmarksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3BulkAddProjectBookmarks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3InviteMembersMutation = (
  options?: Partial<Options<ProjectsV3InviteMembersData>>,
): UseMutationOptions<
  ProjectsV3InviteMembersResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3InviteMembersData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3InviteMembersResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3InviteMembersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3InviteMembers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3BulkInviteMembersMutation = (
  options?: Partial<Options<ProjectsV3BulkInviteMembersData>>,
): UseMutationOptions<
  ProjectsV3BulkInviteMembersResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3BulkInviteMembersData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3BulkInviteMembersResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3BulkInviteMembersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3BulkInviteMembers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3InspectWmtsCustomDataMutation = (
  options?: Partial<Options<ProjectsV3InspectWmtsCustomDataData>>,
): UseMutationOptions<
  ProjectsV3InspectWmtsCustomDataResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3InspectWmtsCustomDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3InspectWmtsCustomDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3InspectWmtsCustomDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3InspectWmtsCustomData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3AddWmtsCustomDataMutation = (
  options?: Partial<Options<ProjectsV3AddWmtsCustomDataData>>,
): UseMutationOptions<
  ProjectsV3AddWmtsCustomDataResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3AddWmtsCustomDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3AddWmtsCustomDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3AddWmtsCustomDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3AddWmtsCustomData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3AddShapefileCustomDataMutation = (
  options?: Partial<Options<ProjectsV3AddShapefileCustomDataData>>,
): UseMutationOptions<
  ProjectsV3AddShapefileCustomDataResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3AddShapefileCustomDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3AddShapefileCustomDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3AddShapefileCustomDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3AddShapefileCustomData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3ListCustomDataQueryKey = (options: Options<ProjectsV3ListCustomDataData>) =>
  createQueryKey('projectsV3ListCustomData', options);

export const projectsV3ListCustomDataOptions = (options: Options<ProjectsV3ListCustomDataData>) =>
  queryOptions<
    ProjectsV3ListCustomDataResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListCustomDataResponse,
    ReturnType<typeof projectsV3ListCustomDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListCustomData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListCustomDataQueryKey(options),
  });

export const projectsV3ListProjectAgencyHistoryQueryKey = (options: Options<ProjectsV3ListProjectAgencyHistoryData>) =>
  createQueryKey('projectsV3ListProjectAgencyHistory', options);

export const projectsV3ListProjectAgencyHistoryOptions = (options: Options<ProjectsV3ListProjectAgencyHistoryData>) =>
  queryOptions<
    ProjectsV3ListProjectAgencyHistoryResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListProjectAgencyHistoryResponse,
    ReturnType<typeof projectsV3ListProjectAgencyHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListProjectAgencyHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListProjectAgencyHistoryQueryKey(options),
  });

export const projectsV3ListProjectConnectbaseTasksQueryKey = (
  options: Options<ProjectsV3ListProjectConnectbaseTasksData>,
) => createQueryKey('projectsV3ListProjectConnectbaseTasks', options);

export const projectsV3ListProjectConnectbaseTasksOptions = (
  options: Options<ProjectsV3ListProjectConnectbaseTasksData>,
) =>
  queryOptions<
    ProjectsV3ListProjectConnectbaseTasksResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListProjectConnectbaseTasksResponse,
    ReturnType<typeof projectsV3ListProjectConnectbaseTasksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListProjectConnectbaseTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListProjectConnectbaseTasksQueryKey(options),
  });

export const projectsV3SetCustomDataVisibilityMutation = (
  options?: Partial<Options<ProjectsV3SetCustomDataVisibilityData>>,
): UseMutationOptions<
  ProjectsV3SetCustomDataVisibilityResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3SetCustomDataVisibilityData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3SetCustomDataVisibilityResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3SetCustomDataVisibilityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3SetCustomDataVisibility({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3SetCustomDataLabelMutation = (
  options?: Partial<Options<ProjectsV3SetCustomDataLabelData>>,
): UseMutationOptions<
  ProjectsV3SetCustomDataLabelResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3SetCustomDataLabelData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3SetCustomDataLabelResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3SetCustomDataLabelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3SetCustomDataLabel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3SetCustomDataCategoriesMutation = (
  options?: Partial<Options<ProjectsV3SetCustomDataCategoriesData>>,
): UseMutationOptions<
  ProjectsV3SetCustomDataCategoriesResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3SetCustomDataCategoriesData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3SetCustomDataCategoriesResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3SetCustomDataCategoriesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3SetCustomDataCategories({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3DownloadCustomDataSourceQueryKey = (options: Options<ProjectsV3DownloadCustomDataSourceData>) =>
  createQueryKey('projectsV3DownloadCustomDataSource', options);

export const projectsV3DownloadCustomDataSourceOptions = (options: Options<ProjectsV3DownloadCustomDataSourceData>) =>
  queryOptions<
    ProjectsV3DownloadCustomDataSourceResponse,
    AxiosError<DefaultError>,
    ProjectsV3DownloadCustomDataSourceResponse,
    ReturnType<typeof projectsV3DownloadCustomDataSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3DownloadCustomDataSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3DownloadCustomDataSourceQueryKey(options),
  });

export const projectsV3ListGeoRefMapsForProjectQueryKey = (options: Options<ProjectsV3ListGeoRefMapsForProjectData>) =>
  createQueryKey('projectsV3ListGeoRefMapsForProject', options);

export const projectsV3ListGeoRefMapsForProjectOptions = (options: Options<ProjectsV3ListGeoRefMapsForProjectData>) =>
  queryOptions<
    ProjectsV3ListGeoRefMapsForProjectResponse,
    AxiosError<DefaultError>,
    ProjectsV3ListGeoRefMapsForProjectResponse,
    ReturnType<typeof projectsV3ListGeoRefMapsForProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3ListGeoRefMapsForProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3ListGeoRefMapsForProjectQueryKey(options),
  });

export const projectsV3ListGeoRefMapsForProjectInfiniteQueryKey = (
  options: Options<ProjectsV3ListGeoRefMapsForProjectData>,
): QueryKey<Options<ProjectsV3ListGeoRefMapsForProjectData>> =>
  createQueryKey('projectsV3ListGeoRefMapsForProject', options, true);

export const projectsV3ListGeoRefMapsForProjectInfiniteOptions = (
  options: Options<ProjectsV3ListGeoRefMapsForProjectData>,
) => {
  const opts = infiniteQueryOptions<
    ProjectsV3ListGeoRefMapsForProjectResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProjectsV3ListGeoRefMapsForProjectResponse>,
    QueryKey<Options<ProjectsV3ListGeoRefMapsForProjectData>>,
    | number
    | null
    | Pick<QueryKey<Options<ProjectsV3ListGeoRefMapsForProjectData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProjectsV3ListGeoRefMapsForProjectData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsV3ListGeoRefMapsForProject({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: projectsV3ListGeoRefMapsForProjectInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const projectsV3DeleteCustomDataMutation = (
  options?: Partial<Options<ProjectsV3DeleteCustomDataData>>,
): UseMutationOptions<
  ProjectsV3DeleteCustomDataResponse,
  AxiosError<DefaultError>,
  Options<ProjectsV3DeleteCustomDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ProjectsV3DeleteCustomDataResponse,
    AxiosError<DefaultError>,
    Options<ProjectsV3DeleteCustomDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectsV3DeleteCustomData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectsV3GetProjectIntelligenceQueryKey = (options: Options<ProjectsV3GetProjectIntelligenceData>) =>
  createQueryKey('projectsV3GetProjectIntelligence', options);

export const projectsV3GetProjectIntelligenceOptions = (options: Options<ProjectsV3GetProjectIntelligenceData>) =>
  queryOptions<
    ProjectsV3GetProjectIntelligenceResponse,
    AxiosError<DefaultError>,
    ProjectsV3GetProjectIntelligenceResponse,
    ReturnType<typeof projectsV3GetProjectIntelligenceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectsV3GetProjectIntelligence({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectsV3GetProjectIntelligenceQueryKey(options),
  });

export const drawingsV3ListDrawingsQueryKey = (options: Options<DrawingsV3ListDrawingsData>) =>
  createQueryKey('drawingsV3ListDrawings', options);

export const drawingsV3ListDrawingsOptions = (options: Options<DrawingsV3ListDrawingsData>) =>
  queryOptions<
    DrawingsV3ListDrawingsResponse,
    AxiosError<DefaultError>,
    DrawingsV3ListDrawingsResponse,
    ReturnType<typeof drawingsV3ListDrawingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await drawingsV3ListDrawings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: drawingsV3ListDrawingsQueryKey(options),
  });

export const drawingsV3CreateDrawingMutation = (
  options?: Partial<Options<DrawingsV3CreateDrawingData>>,
): UseMutationOptions<
  DrawingsV3CreateDrawingResponse,
  AxiosError<DefaultError>,
  Options<DrawingsV3CreateDrawingData>
> => {
  const mutationOptions: UseMutationOptions<
    DrawingsV3CreateDrawingResponse,
    AxiosError<DefaultError>,
    Options<DrawingsV3CreateDrawingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drawingsV3CreateDrawing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drawingsV3ArchiveDrawingMutation = (
  options?: Partial<Options<DrawingsV3ArchiveDrawingData>>,
): UseMutationOptions<
  DrawingsV3ArchiveDrawingResponse,
  AxiosError<DefaultError>,
  Options<DrawingsV3ArchiveDrawingData>
> => {
  const mutationOptions: UseMutationOptions<
    DrawingsV3ArchiveDrawingResponse,
    AxiosError<DefaultError>,
    Options<DrawingsV3ArchiveDrawingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drawingsV3ArchiveDrawing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drawingsV3GetDrawingQueryKey = (options: Options<DrawingsV3GetDrawingData>) =>
  createQueryKey('drawingsV3GetDrawing', options);

export const drawingsV3GetDrawingOptions = (options: Options<DrawingsV3GetDrawingData>) =>
  queryOptions<
    DrawingsV3GetDrawingResponse,
    AxiosError<DefaultError>,
    DrawingsV3GetDrawingResponse,
    ReturnType<typeof drawingsV3GetDrawingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await drawingsV3GetDrawing({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: drawingsV3GetDrawingQueryKey(options),
  });

export const drawingsV3UpdateDrawingMutation = (
  options?: Partial<Options<DrawingsV3UpdateDrawingData>>,
): UseMutationOptions<
  DrawingsV3UpdateDrawingResponse,
  AxiosError<DefaultError>,
  Options<DrawingsV3UpdateDrawingData>
> => {
  const mutationOptions: UseMutationOptions<
    DrawingsV3UpdateDrawingResponse,
    AxiosError<DefaultError>,
    Options<DrawingsV3UpdateDrawingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drawingsV3UpdateDrawing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drawingsV3ListChangesQueryKey = (options: Options<DrawingsV3ListChangesData>) =>
  createQueryKey('drawingsV3ListChanges', options);

export const drawingsV3ListChangesOptions = (options: Options<DrawingsV3ListChangesData>) =>
  queryOptions<
    DrawingsV3ListChangesResponse,
    AxiosError<DefaultError>,
    DrawingsV3ListChangesResponse,
    ReturnType<typeof drawingsV3ListChangesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await drawingsV3ListChanges({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: drawingsV3ListChangesQueryKey(options),
  });

export const drawingsV3ApplyChangesMutation = (
  options?: Partial<Options<DrawingsV3ApplyChangesData>>,
): UseMutationOptions<
  DrawingsV3ApplyChangesResponse,
  AxiosError<DefaultError>,
  Options<DrawingsV3ApplyChangesData>
> => {
  const mutationOptions: UseMutationOptions<
    DrawingsV3ApplyChangesResponse,
    AxiosError<DefaultError>,
    Options<DrawingsV3ApplyChangesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drawingsV3ApplyChanges({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drawingsV3RestoreDrawingMutation = (
  options?: Partial<Options<DrawingsV3RestoreDrawingData>>,
): UseMutationOptions<
  DrawingsV3RestoreDrawingResponse,
  AxiosError<DefaultError>,
  Options<DrawingsV3RestoreDrawingData>
> => {
  const mutationOptions: UseMutationOptions<
    DrawingsV3RestoreDrawingResponse,
    AxiosError<DefaultError>,
    Options<DrawingsV3RestoreDrawingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drawingsV3RestoreDrawing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const drawingsV3GetHistoryQueryKey = (options: Options<DrawingsV3GetHistoryData>) =>
  createQueryKey('drawingsV3GetHistory', options);

export const drawingsV3GetHistoryOptions = (options: Options<DrawingsV3GetHistoryData>) =>
  queryOptions<
    DrawingsV3GetHistoryResponse,
    AxiosError<DefaultError>,
    DrawingsV3GetHistoryResponse,
    ReturnType<typeof drawingsV3GetHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await drawingsV3GetHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: drawingsV3GetHistoryQueryKey(options),
  });

export const drawingsV3DuplicateDrawingMutation = (
  options?: Partial<Options<DrawingsV3DuplicateDrawingData>>,
): UseMutationOptions<
  DrawingsV3DuplicateDrawingResponse,
  AxiosError<DefaultError>,
  Options<DrawingsV3DuplicateDrawingData>
> => {
  const mutationOptions: UseMutationOptions<
    DrawingsV3DuplicateDrawingResponse,
    AxiosError<DefaultError>,
    Options<DrawingsV3DuplicateDrawingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await drawingsV3DuplicateDrawing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const uploadsV3PresignUploadMutation = (
  options?: Partial<Options<UploadsV3PresignUploadData>>,
): UseMutationOptions<
  UploadsV3PresignUploadResponse,
  AxiosError<DefaultError>,
  Options<UploadsV3PresignUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadsV3PresignUploadResponse,
    AxiosError<DefaultError>,
    Options<UploadsV3PresignUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadsV3PresignUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const uploadsV3RegisterUploadMutation = (
  options?: Partial<Options<UploadsV3RegisterUploadData>>,
): UseMutationOptions<
  UploadsV3RegisterUploadResponse,
  AxiosError<DefaultError>,
  Options<UploadsV3RegisterUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadsV3RegisterUploadResponse,
    AxiosError<DefaultError>,
    Options<UploadsV3RegisterUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadsV3RegisterUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const uploadsV3GetUploadQueryKey = (options: Options<UploadsV3GetUploadData>) =>
  createQueryKey('uploadsV3GetUpload', options);

export const uploadsV3GetUploadOptions = (options: Options<UploadsV3GetUploadData>) =>
  queryOptions<
    UploadsV3GetUploadResponse,
    AxiosError<DefaultError>,
    UploadsV3GetUploadResponse,
    ReturnType<typeof uploadsV3GetUploadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await uploadsV3GetUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: uploadsV3GetUploadQueryKey(options),
  });

export const commentThreadsV3ListCommentThreadsQueryKey = (options: Options<CommentThreadsV3ListCommentThreadsData>) =>
  createQueryKey('commentThreadsV3ListCommentThreads', options);

export const commentThreadsV3ListCommentThreadsOptions = (options: Options<CommentThreadsV3ListCommentThreadsData>) =>
  queryOptions<
    CommentThreadsV3ListCommentThreadsResponse,
    AxiosError<DefaultError>,
    CommentThreadsV3ListCommentThreadsResponse,
    ReturnType<typeof commentThreadsV3ListCommentThreadsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commentThreadsV3ListCommentThreads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: commentThreadsV3ListCommentThreadsQueryKey(options),
  });

export const commentThreadsV3CreateCommentThreadMutation = (
  options?: Partial<Options<CommentThreadsV3CreateCommentThreadData>>,
): UseMutationOptions<
  CommentThreadsV3CreateCommentThreadResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3CreateCommentThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3CreateCommentThreadResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3CreateCommentThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3CreateCommentThread({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3ListTaggableUsersQueryKey = (options: Options<CommentThreadsV3ListTaggableUsersData>) =>
  createQueryKey('commentThreadsV3ListTaggableUsers', options);

export const commentThreadsV3ListTaggableUsersOptions = (options: Options<CommentThreadsV3ListTaggableUsersData>) =>
  queryOptions<
    CommentThreadsV3ListTaggableUsersResponse,
    AxiosError<DefaultError>,
    CommentThreadsV3ListTaggableUsersResponse,
    ReturnType<typeof commentThreadsV3ListTaggableUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commentThreadsV3ListTaggableUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: commentThreadsV3ListTaggableUsersQueryKey(options),
  });

export const commentThreadsV3DeleteCommentThreadMutation = (
  options?: Partial<Options<CommentThreadsV3DeleteCommentThreadData>>,
): UseMutationOptions<
  CommentThreadsV3DeleteCommentThreadResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3DeleteCommentThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3DeleteCommentThreadResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3DeleteCommentThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3DeleteCommentThread({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3GetCommentThreadQueryKey = (options: Options<CommentThreadsV3GetCommentThreadData>) =>
  createQueryKey('commentThreadsV3GetCommentThread', options);

export const commentThreadsV3GetCommentThreadOptions = (options: Options<CommentThreadsV3GetCommentThreadData>) =>
  queryOptions<
    CommentThreadsV3GetCommentThreadResponse,
    AxiosError<DefaultError>,
    CommentThreadsV3GetCommentThreadResponse,
    ReturnType<typeof commentThreadsV3GetCommentThreadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commentThreadsV3GetCommentThread({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: commentThreadsV3GetCommentThreadQueryKey(options),
  });

export const commentThreadsV3CreateCommentMutation = (
  options?: Partial<Options<CommentThreadsV3CreateCommentData>>,
): UseMutationOptions<
  CommentThreadsV3CreateCommentResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3CreateCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3CreateCommentResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3CreateCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3CreateComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3DeleteCommentMutation = (
  options?: Partial<Options<CommentThreadsV3DeleteCommentData>>,
): UseMutationOptions<
  CommentThreadsV3DeleteCommentResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3DeleteCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3DeleteCommentResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3DeleteCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3DeleteComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3UpdateCommentMutation = (
  options?: Partial<Options<CommentThreadsV3UpdateCommentData>>,
): UseMutationOptions<
  CommentThreadsV3UpdateCommentResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3UpdateCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3UpdateCommentResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3UpdateCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3UpdateComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3ResolveCommentThreadMutation = (
  options?: Partial<Options<CommentThreadsV3ResolveCommentThreadData>>,
): UseMutationOptions<
  CommentThreadsV3ResolveCommentThreadResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3ResolveCommentThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3ResolveCommentThreadResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3ResolveCommentThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3ResolveCommentThread({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3ReopenCommentThreadMutation = (
  options?: Partial<Options<CommentThreadsV3ReopenCommentThreadData>>,
): UseMutationOptions<
  CommentThreadsV3ReopenCommentThreadResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3ReopenCommentThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3ReopenCommentThreadResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3ReopenCommentThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3ReopenCommentThread({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const commentThreadsV3RestoreCommentThreadMutation = (
  options?: Partial<Options<CommentThreadsV3RestoreCommentThreadData>>,
): UseMutationOptions<
  CommentThreadsV3RestoreCommentThreadResponse,
  AxiosError<DefaultError>,
  Options<CommentThreadsV3RestoreCommentThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentThreadsV3RestoreCommentThreadResponse,
    AxiosError<DefaultError>,
    Options<CommentThreadsV3RestoreCommentThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentThreadsV3RestoreCommentThread({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
